var map = {
	".": [
		272,
		9
	],
	"./": [
		272,
		9
	],
	"./App": [
		405,
		9
	],
	"./App.js": [
		405,
		9
	],
	"./assets/96c/about.scss": [
		1365,
		7,
		280
	],
	"./assets/96c/app-download.scss": [
		1366,
		7,
		281
	],
	"./assets/96c/base.scss": [
		1367,
		7,
		282
	],
	"./assets/96c/casino.scss": [
		1368,
		7,
		283
	],
	"./assets/96c/change-language.scss": [
		1369,
		7,
		284
	],
	"./assets/96c/cockfight.scss": [
		1370,
		7,
		285
	],
	"./assets/96c/desktop.scss": [
		1371,
		7,
		286
	],
	"./assets/96c/download.scss": [
		1372,
		7,
		287
	],
	"./assets/96c/e-sports.scss": [
		1373,
		7,
		288
	],
	"./assets/96c/edit-dob-popup.scss": [
		1374,
		7,
		289
	],
	"./assets/96c/fastgames.scss": [
		1375,
		7,
		290
	],
	"./assets/96c/favourite.scss": [
		1376,
		7,
		291
	],
	"./assets/96c/fishing.scss": [
		1377,
		7,
		292
	],
	"./assets/96c/floating_freespin_icon.scss": [
		1378,
		7,
		293
	],
	"./assets/96c/floating_notification.scss": [
		1379,
		7,
		294
	],
	"./assets/96c/font.scss": [
		1380,
		7,
		295
	],
	"./assets/96c/four-d.scss": [
		1381,
		7,
		296
	],
	"./assets/96c/games.scss": [
		1382,
		7,
		297
	],
	"./assets/96c/home.scss": [
		1383,
		7,
		298
	],
	"./assets/96c/index.scss": [
		1384,
		7,
		299
	],
	"./assets/96c/leaderboard.scss": [
		1385,
		7,
		300
	],
	"./assets/96c/loading.scss": [
		1386,
		7,
		301
	],
	"./assets/96c/lottery.scss": [
		1387,
		7,
		302
	],
	"./assets/96c/m-provider-sub-game.scss": [
		1388,
		7,
		303
	],
	"./assets/96c/maintenance.scss": [
		1389,
		7,
		304
	],
	"./assets/96c/member.scss": [
		1390,
		7,
		305
	],
	"./assets/96c/message-detail-popup.scss": [
		1391,
		7,
		306
	],
	"./assets/96c/mixinVariables.scss": [
		1392,
		7,
		307
	],
	"./assets/96c/mobile.scss": [
		1393,
		7,
		308
	],
	"./assets/96c/modal.scss": [
		1394,
		7,
		309
	],
	"./assets/96c/newsletter.scss": [
		1395,
		7,
		310
	],
	"./assets/96c/poker.scss": [
		1396,
		7,
		311
	],
	"./assets/96c/promos-apply.scss": [
		1397,
		7,
		312
	],
	"./assets/96c/promos-details.scss": [
		1398,
		7,
		313
	],
	"./assets/96c/promos-transfer.scss": [
		1399,
		7,
		314
	],
	"./assets/96c/promos.scss": [
		1400,
		7,
		315
	],
	"./assets/96c/promote-section-banner.scss": [
		1401,
		7,
		316
	],
	"./assets/96c/providerLandingPage.scss": [
		1402,
		7,
		317
	],
	"./assets/96c/rebate.scss": [
		1403,
		7,
		318
	],
	"./assets/96c/register.scss": [
		1404,
		7,
		319
	],
	"./assets/96c/reward.scss": [
		1405,
		7,
		320
	],
	"./assets/96c/slick-slider.scss": [
		1406,
		7,
		321
	],
	"./assets/96c/sliderRecaptcha-popup/desktop/sliderRecaptcha-popup.scss": [
		1407,
		7,
		322
	],
	"./assets/96c/sliderRecaptcha-popup/mobile/sliderRecaptcha-popup.scss": [
		1408,
		7,
		323
	],
	"./assets/96c/slots.scss": [
		1409,
		7,
		324
	],
	"./assets/96c/sponsorship.scss": [
		1410,
		7,
		325
	],
	"./assets/96c/sports.scss": [
		1411,
		7,
		326
	],
	"./assets/96c/standardButton.scss": [
		1412,
		7,
		327
	],
	"./assets/96c/standardForm.scss": [
		1413,
		7,
		328
	],
	"./assets/96c/standardNotification.scss": [
		1414,
		7,
		329
	],
	"./assets/96c/standardPopup.scss": [
		1415,
		7,
		330
	],
	"./assets/96c/standardTab.scss": [
		1416,
		7,
		331
	],
	"./assets/96c/vars.scss": [
		1417,
		7,
		332
	],
	"./assets/96c/vip.scss": [
		1418,
		7,
		333
	],
	"./assets/96c/wap.scss": [
		1419,
		7,
		334
	],
	"./assets/fonts/Arial.woff": [
		1420,
		7,
		346
	],
	"./assets/fonts/AvertaStd-Regular.woff": [
		1421,
		7,
		347
	],
	"./assets/fonts/KohSantepheap-Regular.woff": [
		1422,
		7,
		348
	],
	"./assets/fonts/Nunito-Black.woff": [
		1423,
		7,
		349
	],
	"./assets/fonts/Nunito-Bold.woff": [
		1424,
		7,
		350
	],
	"./assets/fonts/Nunito-ExtraBold.woff": [
		1425,
		7,
		351
	],
	"./assets/fonts/Nunito-Regular.woff": [
		1426,
		7,
		352
	],
	"./assets/fonts/Nunito-SemiBold.woff": [
		1427,
		7,
		353
	],
	"./assets/fonts/NunitoSans-Black.ttf": [
		1428,
		7,
		354
	],
	"./assets/fonts/NunitoSans-Bold.ttf": [
		1429,
		7,
		355
	],
	"./assets/fonts/NunitoSans-ExtraBold.woff": [
		1430,
		7,
		356
	],
	"./assets/fonts/NunitoSans-ExtraLight.woff": [
		1431,
		7,
		357
	],
	"./assets/fonts/NunitoSans-Regular.woff": [
		1432,
		7,
		358
	],
	"./assets/fonts/backup/Nunito-Bold.woff": [
		1433,
		7,
		359
	],
	"./assets/fonts/backup/Nunito-ExtraBold.woff": [
		1434,
		7,
		360
	],
	"./assets/fonts/backup/Nunito-Regular.woff": [
		1435,
		7,
		361
	],
	"./assets/fonts/backup/Nunito-SemiBold.woff": [
		1436,
		7,
		362
	],
	"./components/SVGElements": [
		24,
		9
	],
	"./components/SVGElements.js": [
		24,
		9
	],
	"./components/ScrollToLoad": [
		164,
		9
	],
	"./components/ScrollToLoad.js": [
		164,
		9
	],
	"./components/TurnstileWidget/Turnstile": [
		154,
		9
	],
	"./components/TurnstileWidget/Turnstile.js": [
		154,
		9
	],
	"./components/atoms/button/button": [
		93,
		9
	],
	"./components/atoms/button/button.js": [
		93,
		9
	],
	"./components/atoms/button/button.module.scss": [
		311,
		7
	],
	"./components/atoms/image/image-component": [
		225,
		9
	],
	"./components/atoms/image/image-component.js": [
		225,
		9
	],
	"./components/atoms/input/input": [
		173,
		9
	],
	"./components/atoms/input/input.js": [
		173,
		9
	],
	"./components/atoms/input/input.module.scss": [
		598,
		7
	],
	"./components/atoms/label/label": [
		469,
		9
	],
	"./components/atoms/label/label.js": [
		469,
		9
	],
	"./components/atoms/label/label.module.scss": [
		524,
		7
	],
	"./components/atoms/reminder-note/reminder-note": [
		470,
		9
	],
	"./components/atoms/reminder-note/reminder-note.js": [
		470,
		9
	],
	"./components/atoms/reminder-note/reminder-note.module.scss": [
		597,
		7
	],
	"./components/atoms/text/text": [
		167,
		9
	],
	"./components/atoms/text/text.js": [
		167,
		9
	],
	"./components/atoms/text/text.module.scss": [
		1437,
		7,
		335
	],
	"./components/atoms/text/text.scss": [
		713,
		7
	],
	"./components/customDatePicker": [
		66,
		9
	],
	"./components/customDatePicker.js": [
		66,
		9
	],
	"./components/floating-freespin": [
		241,
		9
	],
	"./components/floating-freespin/": [
		241,
		9
	],
	"./components/floating-freespin/close-button": [
		515,
		9
	],
	"./components/floating-freespin/close-button.js": [
		515,
		9
	],
	"./components/floating-freespin/floating-icon-dragger": [
		513,
		9
	],
	"./components/floating-freespin/floating-icon-dragger.js": [
		513,
		9
	],
	"./components/floating-freespin/freespin-modal": [
		514,
		9
	],
	"./components/floating-freespin/freespin-modal.js": [
		514,
		9
	],
	"./components/floating-freespin/index": [
		241,
		9
	],
	"./components/floating-freespin/index.js": [
		241,
		9
	],
	"./components/floating-freespin/useFreespin": [
		516,
		9
	],
	"./components/floating-freespin/useFreespin.js": [
		516,
		9
	],
	"./components/molecules/auth-otp-tabs/auth-otp-tabs": [
		202,
		9,
		3
	],
	"./components/molecules/auth-otp-tabs/auth-otp-tabs.js": [
		202,
		9,
		3
	],
	"./components/molecules/auth-otp-tabs/auth-otp-tabs.module.scss": [
		1362,
		7,
		336
	],
	"./components/molecules/auth-settings/auth-settings": [
		54,
		9
	],
	"./components/molecules/auth-settings/auth-settings.js": [
		54,
		9
	],
	"./components/molecules/bank-icon/bank-icon": [
		25,
		9
	],
	"./components/molecules/bank-icon/bank-icon.js": [
		25,
		9
	],
	"./components/molecules/form-field/form-field": [
		108,
		9
	],
	"./components/molecules/form-field/form-field.js": [
		108,
		9
	],
	"./components/molecules/form-field/form-field.module.scss": [
		96,
		7
	],
	"./components/molecules/menu-item/menu-item": [
		417,
		9
	],
	"./components/molecules/menu-item/menu-item.js": [
		417,
		9
	],
	"./components/molecules/menu-item/menu-item.module.scss": [
		309,
		7
	],
	"./components/molecules/menu-list/menu-list": [
		416,
		9
	],
	"./components/molecules/menu-list/menu-list.js": [
		416,
		9
	],
	"./components/molecules/menu-list/menu-list.module.scss": [
		590,
		7
	],
	"./components/molecules/option/option": [
		373,
		9
	],
	"./components/molecules/option/option.js": [
		373,
		9
	],
	"./components/molecules/otp-form-field/otp-form-field": [
		226,
		9
	],
	"./components/molecules/otp-form-field/otp-form-field.js": [
		226,
		9
	],
	"./components/molecules/otp-form-field/otp-form-field.module.scss": [
		105,
		7
	],
	"./components/molecules/password-guideline/password-guideline": [
		251,
		9
	],
	"./components/molecules/password-guideline/password-guideline.js": [
		251,
		9
	],
	"./components/molecules/password-guideline/password-guideline.module.scss": [
		179,
		7
	],
	"./components/molecules/passwordInput/passwordInput": [
		316,
		9
	],
	"./components/molecules/passwordInput/passwordInput.js": [
		316,
		9
	],
	"./components/molecules/passwordInput/passwordInput.module.scss": [
		199,
		7
	],
	"./components/molecules/payment-icon/payment-icon": [
		75,
		9
	],
	"./components/molecules/payment-icon/payment-icon.js": [
		75,
		9
	],
	"./components/molecules/phone-field/phone-field": [
		907,
		9,
		32
	],
	"./components/molecules/phone-field/phone-field.js": [
		907,
		9,
		32
	],
	"./components/molecules/phone-field/phone-field.module.scss": [
		1364,
		7,
		337
	],
	"./components/molecules/phone-otp-method-selection/phone-otp-method-selection": [
		608,
		9,
		15
	],
	"./components/molecules/phone-otp-method-selection/phone-otp-method-selection.js": [
		608,
		9,
		15
	],
	"./components/molecules/phone-otp-method-selection/phone-otp-method-selection.module.scss": [
		1363,
		7,
		338
	],
	"./components/molecules/select-dropdown/select-dropdown": [
		372,
		9
	],
	"./components/molecules/select-dropdown/select-dropdown.js": [
		372,
		9
	],
	"./components/molecules/settings-tab/settings-tab": [
		374,
		9
	],
	"./components/molecules/settings-tab/settings-tab.js": [
		374,
		9
	],
	"./components/molecules/settings-tab/settings-tab.module.scss": [
		313,
		7
	],
	"./components/molecules/svg-icon/svg-icon": [
		243,
		9
	],
	"./components/molecules/svg-icon/svg-icon.js": [
		243,
		9
	],
	"./components/molecules/svg-icon/svg-icon.module.scss": [
		310,
		7
	],
	"./components/organisms/add-crypto-address-popup/add-crypto-address-popup": [
		231,
		9
	],
	"./components/organisms/add-crypto-address-popup/add-crypto-address-popup.js": [
		231,
		9
	],
	"./components/organisms/add-crypto-address-popup/add-crypto-address-popup.module.scss": [
		91,
		7
	],
	"./components/organisms/bank-statement-upload-section/bank-statement-upload-section": [
		238,
		9
	],
	"./components/organisms/bank-statement-upload-section/bank-statement-upload-section.js": [
		238,
		9
	],
	"./components/organisms/bank-statement-upload-section/bank-statement-upload-section.module.scss": [
		138,
		7
	],
	"./components/organisms/edit-verify-auth-popup/edit-verify-auth-popup": [
		616,
		9,
		62
	],
	"./components/organisms/edit-verify-auth-popup/edit-verify-auth-popup-hook": [
		854,
		9,
		190
	],
	"./components/organisms/edit-verify-auth-popup/edit-verify-auth-popup-hook.js": [
		854,
		9,
		190
	],
	"./components/organisms/edit-verify-auth-popup/edit-verify-auth-popup.js": [
		616,
		9,
		62
	],
	"./components/organisms/edit-verify-auth-popup/edit-verify-auth-popup.module.scss": [
		1359,
		7,
		339
	],
	"./components/organisms/email-verification-popup/email-verifiaction-popup-hook": [
		851,
		9,
		191
	],
	"./components/organisms/email-verification-popup/email-verifiaction-popup-hook.js": [
		851,
		9,
		191
	],
	"./components/organisms/email-verification-popup/email-verification-popup": [
		613,
		9,
		63
	],
	"./components/organisms/email-verification-popup/email-verification-popup.js": [
		613,
		9,
		63
	],
	"./components/organisms/email-verification-popup/email-verification-popup.module.scss": [
		1356,
		7,
		340
	],
	"./components/organisms/enter-pin-popup/enter-pin-popup": [
		617,
		9,
		69
	],
	"./components/organisms/enter-pin-popup/enter-pin-popup.js": [
		617,
		9,
		69
	],
	"./components/organisms/enter-pin-popup/enter-pin-popup.module.scss": [
		1360,
		7,
		341
	],
	"./components/organisms/force-change-password/force-change-password": [
		511,
		9
	],
	"./components/organisms/force-change-password/force-change-password.js": [
		511,
		9
	],
	"./components/organisms/google-auth-popup/google-auth-popup": [
		615,
		9,
		64
	],
	"./components/organisms/google-auth-popup/google-auth-popup-hook": [
		853,
		9,
		192
	],
	"./components/organisms/google-auth-popup/google-auth-popup-hook.js": [
		853,
		9,
		192
	],
	"./components/organisms/google-auth-popup/google-auth-popup.js": [
		615,
		9,
		64
	],
	"./components/organisms/google-auth-popup/google-auth-popup.module.scss": [
		1358,
		7,
		342
	],
	"./components/organisms/hamburger-menus/hamburger-menus": [
		415,
		9
	],
	"./components/organisms/hamburger-menus/hamburger-menus.js": [
		415,
		9
	],
	"./components/organisms/hamburger-menus/hamburger-menus.module.scss": [
		221,
		7
	],
	"./components/organisms/kyc-sumsub-notification-popup/kyc-sumsub-notification-popup": [
		618,
		9,
		70
	],
	"./components/organisms/kyc-sumsub-notification-popup/kyc-sumsub-notification-popup.js": [
		618,
		9,
		70
	],
	"./components/organisms/kyc-sumsub-notification-popup/kyc-sumsub-notification-popup.module.scss": [
		1361,
		7,
		343
	],
	"./components/organisms/kyc-sumsub/kyc-sumsub": [
		375,
		9
	],
	"./components/organisms/kyc-sumsub/kyc-sumsub.js": [
		375,
		9
	],
	"./components/organisms/kyc-sumsub/kyc-sumsub.module.scss": [
		51,
		7
	],
	"./components/organisms/phone-verification-popup/phone-verification-popup": [
		614,
		9,
		65
	],
	"./components/organisms/phone-verification-popup/phone-verification-popup.hook": [
		852,
		9,
		193
	],
	"./components/organisms/phone-verification-popup/phone-verification-popup.hook.js": [
		852,
		9,
		193
	],
	"./components/organisms/phone-verification-popup/phone-verification-popup.js": [
		614,
		9,
		65
	],
	"./components/organisms/phone-verification-popup/phone-verification-popup.module.scss": [
		1357,
		7,
		344
	],
	"./components/organisms/popup/popup": [
		107,
		9
	],
	"./components/organisms/popup/popup.js": [
		107,
		9
	],
	"./components/organisms/popup/popup.module.scss": [
		147,
		7
	],
	"./components/organisms/promotion-transfer/promotion-transfer": [
		318,
		9
	],
	"./components/organisms/promotion-transfer/promotion-transfer.js": [
		318,
		9
	],
	"./components/organisms/promotion-transfer/promotion-transfer.module.scss": [
		106,
		7
	],
	"./components/organisms/set-up-pin-popup/set-up-pin-popup": [
		156,
		9
	],
	"./components/organisms/set-up-pin-popup/set-up-pin-popup-hook": [
		259,
		9
	],
	"./components/organisms/set-up-pin-popup/set-up-pin-popup-hook.js": [
		259,
		9
	],
	"./components/organisms/set-up-pin-popup/set-up-pin-popup.js": [
		156,
		9
	],
	"./components/organisms/set-up-pin-popup/set-up-pin-popup.module.scss": [
		92,
		7
	],
	"./components/organisms/special-for-you/special-for-you": [
		287,
		9
	],
	"./components/organisms/special-for-you/special-for-you.js": [
		287,
		9
	],
	"./components/organisms/special-for-you/special-for-you.module.scss": [
		48,
		7
	],
	"./components/organisms/user-verifications/user-verifications": [
		322,
		9
	],
	"./components/organisms/user-verifications/user-verifications.js": [
		322,
		9
	],
	"./components/organisms/user-verifications/user-verifications.module.scss": [
		267,
		7
	],
	"./components/smallLoading": [
		317,
		9
	],
	"./components/smallLoading.js": [
		317,
		9
	],
	"./components/svgIcon/svgBank": [
		80,
		9
	],
	"./components/svgIcon/svgBank.js": [
		80,
		9
	],
	"./components/svgIcon/svgBankApp": [
		244,
		9
	],
	"./components/svgIcon/svgBankApp.js": [
		244,
		9
	],
	"./components/svgIcon/svgContact": [
		230,
		9
	],
	"./components/svgIcon/svgContact.js": [
		230,
		9
	],
	"./components/svgIcon/svgProvider": [
		270,
		9
	],
	"./components/svgIcon/svgProvider.js": [
		270,
		9
	],
	"./components/svgIcon/svgTransfer": [
		168,
		9
	],
	"./components/svgIcon/svgTransfer.js": [
		168,
		9
	],
	"./handler/routerChangeHandler": [
		512,
		9
	],
	"./handler/routerChangeHandler.js": [
		512,
		9
	],
	"./hooks/affiliate-hook": [
		425,
		9
	],
	"./hooks/affiliate-hook.js": [
		425,
		9
	],
	"./hooks/general-hook": [
		129,
		9
	],
	"./hooks/general-hook.js": [
		129,
		9
	],
	"./hooks/kyc-sumsub-hook": [
		215,
		9
	],
	"./hooks/kyc-sumsub-hook.js": [
		215,
		9
	],
	"./hooks/member-hook": [
		319,
		9
	],
	"./hooks/member-hook.js": [
		319,
		9
	],
	"./hooks/otp-hook": [
		183,
		9
	],
	"./hooks/otp-hook.js": [
		183,
		9
	],
	"./hooks/password-hook": [
		176,
		9
	],
	"./hooks/password-hook.js": [
		176,
		9
	],
	"./hooks/provider-hook": [
		315,
		9
	],
	"./hooks/provider-hook.js": [
		315,
		9
	],
	"./i18n": [
		549,
		9
	],
	"./i18n.js": [
		549,
		9
	],
	"./index": [
		272,
		9
	],
	"./index.js": [
		272,
		9
	],
	"./redux/ThemeOptions": [
		929,
		9,
		194
	],
	"./redux/ThemeOptions.js": [
		929,
		9,
		194
	],
	"./redux/action": [
		10,
		9
	],
	"./redux/action/": [
		10,
		9
	],
	"./redux/action/auth-settings.action": [
		153,
		9
	],
	"./redux/action/auth-settings.action.js": [
		153,
		9
	],
	"./redux/action/banner.action": [
		908,
		9,
		195
	],
	"./redux/action/banner.action.js": [
		908,
		9,
		195
	],
	"./redux/action/deposit.action": [
		346,
		9
	],
	"./redux/action/deposit.action.js": [
		346,
		9
	],
	"./redux/action/dropdown.action": [
		344,
		9
	],
	"./redux/action/dropdown.action.js": [
		344,
		9
	],
	"./redux/action/floatingNotification.action": [
		345,
		9
	],
	"./redux/action/floatingNotification.action.js": [
		345,
		9
	],
	"./redux/action/game.action": [
		339,
		9
	],
	"./redux/action/game.action.js": [
		339,
		9
	],
	"./redux/action/general.action": [
		235,
		9
	],
	"./redux/action/general.action.js": [
		235,
		9
	],
	"./redux/action/index": [
		10,
		9
	],
	"./redux/action/index.js": [
		10,
		9
	],
	"./redux/action/kyc-sumsub.action": [
		349,
		9
	],
	"./redux/action/kyc-sumsub.action.js": [
		349,
		9
	],
	"./redux/action/language.action": [
		134,
		9
	],
	"./redux/action/language.action.js": [
		134,
		9
	],
	"./redux/action/layout.action": [
		343,
		9
	],
	"./redux/action/layout.action.js": [
		343,
		9
	],
	"./redux/action/modal.action": [
		342,
		9
	],
	"./redux/action/modal.action.js": [
		342,
		9
	],
	"./redux/action/password.action": [
		214,
		9
	],
	"./redux/action/password.action.js": [
		214,
		9
	],
	"./redux/action/popup.action": [
		29,
		9
	],
	"./redux/action/popup.action.js": [
		29,
		9
	],
	"./redux/action/portal.action": [
		43,
		9
	],
	"./redux/action/portal.action.js": [
		43,
		9
	],
	"./redux/action/promotion.action": [
		157,
		9
	],
	"./redux/action/promotion.action.js": [
		157,
		9
	],
	"./redux/action/provider.action": [
		348,
		9
	],
	"./redux/action/provider.action.js": [
		348,
		9
	],
	"./redux/action/region.action": [
		347,
		9
	],
	"./redux/action/region.action.js": [
		347,
		9
	],
	"./redux/action/register.action": [
		340,
		9
	],
	"./redux/action/register.action.js": [
		340,
		9
	],
	"./redux/action/screen.action": [
		341,
		9
	],
	"./redux/action/screen.action.js": [
		341,
		9
	],
	"./redux/action/system-feature.action": [
		193,
		9
	],
	"./redux/action/system-feature.action.js": [
		193,
		9
	],
	"./redux/action/user.action": [
		59,
		9
	],
	"./redux/action/user.action.js": [
		59,
		9
	],
	"./redux/action/wallet.action": [
		68,
		9
	],
	"./redux/action/wallet.action.js": [
		68,
		9
	],
	"./redux/constant": [
		8,
		9
	],
	"./redux/constant/": [
		8,
		9
	],
	"./redux/constant/auth-settings.constant": [
		337,
		9
	],
	"./redux/constant/auth-settings.constant.js": [
		337,
		9
	],
	"./redux/constant/banner.constant": [
		234,
		9
	],
	"./redux/constant/banner.constant.js": [
		234,
		9
	],
	"./redux/constant/deposit.constant": [
		334,
		9
	],
	"./redux/constant/deposit.constant.js": [
		334,
		9
	],
	"./redux/constant/dropdown.constant": [
		332,
		9
	],
	"./redux/constant/dropdown.constant.js": [
		332,
		9
	],
	"./redux/constant/floatingNotification.constant": [
		333,
		9
	],
	"./redux/constant/floatingNotification.constant.js": [
		333,
		9
	],
	"./redux/constant/game.constant": [
		325,
		9
	],
	"./redux/constant/game.constant.js": [
		325,
		9
	],
	"./redux/constant/general.constant": [
		335,
		9
	],
	"./redux/constant/general.constant.js": [
		335,
		9
	],
	"./redux/constant/index": [
		8,
		9
	],
	"./redux/constant/index.js": [
		8,
		9
	],
	"./redux/constant/kyc-sumsub.constant": [
		160,
		9
	],
	"./redux/constant/kyc-sumsub.constant.js": [
		160,
		9
	],
	"./redux/constant/language.constant": [
		232,
		9
	],
	"./redux/constant/language.constant.js": [
		232,
		9
	],
	"./redux/constant/layout.constant": [
		331,
		9
	],
	"./redux/constant/layout.constant.js": [
		331,
		9
	],
	"./redux/constant/modal.constant": [
		330,
		9
	],
	"./redux/constant/modal.constant.js": [
		330,
		9
	],
	"./redux/constant/password.constant": [
		145,
		9
	],
	"./redux/constant/password.constant.js": [
		145,
		9
	],
	"./redux/constant/popup.constant": [
		213,
		9
	],
	"./redux/constant/popup.constant.js": [
		213,
		9
	],
	"./redux/constant/portal.constant": [
		328,
		9
	],
	"./redux/constant/portal.constant.js": [
		328,
		9
	],
	"./redux/constant/promotion.constant": [
		233,
		9
	],
	"./redux/constant/promotion.constant.js": [
		233,
		9
	],
	"./redux/constant/provider.constant": [
		130,
		9
	],
	"./redux/constant/provider.constant.js": [
		130,
		9
	],
	"./redux/constant/region.constant": [
		338,
		9
	],
	"./redux/constant/region.constant.js": [
		338,
		9
	],
	"./redux/constant/register.constant": [
		326,
		9
	],
	"./redux/constant/register.constant.js": [
		326,
		9
	],
	"./redux/constant/screen.constant": [
		327,
		9
	],
	"./redux/constant/screen.constant.js": [
		327,
		9
	],
	"./redux/constant/system-feature.constant": [
		336,
		9
	],
	"./redux/constant/system-feature.constant.js": [
		336,
		9
	],
	"./redux/constant/user.constant": [
		324,
		9
	],
	"./redux/constant/user.constant.js": [
		324,
		9
	],
	"./redux/constant/wallet.constant": [
		329,
		9
	],
	"./redux/constant/wallet.constant.js": [
		329,
		9
	],
	"./redux/reducer/auth-settings.reducer": [
		400,
		9
	],
	"./redux/reducer/auth-settings.reducer.js": [
		400,
		9
	],
	"./redux/reducer/banner.reducer": [
		403,
		9
	],
	"./redux/reducer/banner.reducer.js": [
		403,
		9
	],
	"./redux/reducer/deposit.reducer": [
		395,
		9
	],
	"./redux/reducer/deposit.reducer.js": [
		395,
		9
	],
	"./redux/reducer/dropdown.reducer": [
		393,
		9
	],
	"./redux/reducer/dropdown.reducer.js": [
		393,
		9
	],
	"./redux/reducer/floatingNotification.reducer": [
		394,
		9
	],
	"./redux/reducer/floatingNotification.reducer.js": [
		394,
		9
	],
	"./redux/reducer/game.reducer": [
		387,
		9
	],
	"./redux/reducer/game.reducer.js": [
		387,
		9
	],
	"./redux/reducer/general.reducer": [
		396,
		9
	],
	"./redux/reducer/general.reducer.js": [
		396,
		9
	],
	"./redux/reducer/kyc-sumsub.reducer": [
		404,
		9
	],
	"./redux/reducer/kyc-sumsub.reducer.js": [
		404,
		9
	],
	"./redux/reducer/language.reducer": [
		383,
		9
	],
	"./redux/reducer/language.reducer.js": [
		383,
		9
	],
	"./redux/reducer/layout.reducer": [
		392,
		9
	],
	"./redux/reducer/layout.reducer.js": [
		392,
		9
	],
	"./redux/reducer/modal.reducer": [
		391,
		9
	],
	"./redux/reducer/modal.reducer.js": [
		391,
		9
	],
	"./redux/reducer/password.reducer": [
		397,
		9
	],
	"./redux/reducer/password.reducer.js": [
		397,
		9
	],
	"./redux/reducer/popup.reducer": [
		290,
		9
	],
	"./redux/reducer/popup.reducer.js": [
		290,
		9
	],
	"./redux/reducer/portal.reducer": [
		389,
		9
	],
	"./redux/reducer/portal.reducer.js": [
		389,
		9
	],
	"./redux/reducer/promotion.reducer": [
		398,
		9
	],
	"./redux/reducer/promotion.reducer.js": [
		398,
		9
	],
	"./redux/reducer/provider.reducer": [
		402,
		9
	],
	"./redux/reducer/provider.reducer.js": [
		402,
		9
	],
	"./redux/reducer/reducer": [
		382,
		9
	],
	"./redux/reducer/reducer.js": [
		382,
		9
	],
	"./redux/reducer/region.reducer": [
		401,
		9
	],
	"./redux/reducer/region.reducer.js": [
		401,
		9
	],
	"./redux/reducer/register.reducer": [
		388,
		9
	],
	"./redux/reducer/register.reducer.js": [
		388,
		9
	],
	"./redux/reducer/screen.reducer": [
		385,
		9
	],
	"./redux/reducer/screen.reducer.js": [
		385,
		9
	],
	"./redux/reducer/system-feature.reducer": [
		399,
		9
	],
	"./redux/reducer/system-feature.reducer.js": [
		399,
		9
	],
	"./redux/reducer/user.reducer": [
		384,
		9
	],
	"./redux/reducer/user.reducer.js": [
		384,
		9
	],
	"./redux/reducer/wallet.reducer": [
		390,
		9
	],
	"./redux/reducer/wallet.reducer.js": [
		390,
		9
	],
	"./redux/selector/selector": [
		6,
		9
	],
	"./redux/selector/selector.js": [
		6,
		9
	],
	"./redux/store/store": [
		289,
		9
	],
	"./redux/store/store.js": [
		289,
		9
	],
	"./setupProxy": [
		930,
		7,
		97,
		111
	],
	"./setupProxy.js": [
		930,
		7,
		97,
		111
	],
	"./utils": [
		98,
		9
	],
	"./utils/": [
		98,
		9
	],
	"./utils/APIClient": [
		250,
		9
	],
	"./utils/APIClient.js": [
		250,
		9
	],
	"./utils/Device": [
		386,
		9
	],
	"./utils/Device.js": [
		386,
		9
	],
	"./utils/EventEmitter": [
		803,
		9,
		196
	],
	"./utils/EventEmitter.js": [
		803,
		9,
		196
	],
	"./utils/common-util": [
		9,
		9
	],
	"./utils/common-util.js": [
		9,
		9
	],
	"./utils/constants": [
		2,
		9
	],
	"./utils/constants.js": [
		2,
		9
	],
	"./utils/core": [
		5,
		9
	],
	"./utils/core.js": [
		5,
		9
	],
	"./utils/date-util": [
		283,
		9
	],
	"./utils/date-util.js": [
		283,
		9
	],
	"./utils/eventEmmiter": [
		161,
		9
	],
	"./utils/eventEmmiter.js": [
		161,
		9
	],
	"./utils/general-util": [
		18,
		9
	],
	"./utils/general-util.js": [
		18,
		9
	],
	"./utils/image": [
		284,
		9
	],
	"./utils/image.js": [
		284,
		9
	],
	"./utils/index": [
		98,
		9
	],
	"./utils/index.js": [
		98,
		9
	],
	"./utils/kyc-sumsub-util": [
		494,
		9
	],
	"./utils/kyc-sumsub-util.js": [
		494,
		9
	],
	"./utils/leaderboard-service": [
		201,
		9
	],
	"./utils/leaderboard-service.js": [
		201,
		9
	],
	"./utils/memberService": [
		128,
		9
	],
	"./utils/memberService.js": [
		128,
		9
	],
	"./utils/notification": [
		13,
		9
	],
	"./utils/notification.js": [
		13,
		9
	],
	"./utils/onNetworkIdle": [
		931,
		9,
		197
	],
	"./utils/onNetworkIdle.js": [
		931,
		9,
		197
	],
	"./utils/otp-util": [
		118,
		9
	],
	"./utils/otp-util.js": [
		118,
		9
	],
	"./utils/password-util": [
		159,
		9
	],
	"./utils/password-util.js": [
		159,
		9
	],
	"./utils/phone-util": [
		240,
		9
	],
	"./utils/phone-util.js": [
		240,
		9
	],
	"./utils/provider": [
		300,
		9
	],
	"./utils/provider-util": [
		755,
		9,
		198
	],
	"./utils/provider-util.js": [
		755,
		9,
		198
	],
	"./utils/provider.js": [
		300,
		9
	],
	"./utils/providerService": [
		751,
		9,
		199
	],
	"./utils/providerService.js": [
		751,
		9,
		199
	],
	"./utils/transaction-helper": [
		7,
		9
	],
	"./utils/transaction-helper.js": [
		7,
		9
	],
	"./utils/transaction-util": [
		15,
		9
	],
	"./utils/transaction-util.js": [
		15,
		9
	],
	"./webapp/components/atoms/text/text": [
		34,
		9
	],
	"./webapp/components/atoms/text/text.js": [
		34,
		9
	],
	"./webapp/layout/footer/component/desktop/Footer": [
		288,
		9
	],
	"./webapp/layout/footer/component/desktop/Footer.js": [
		288,
		9
	],
	"./webapp/layout/footer/component/desktop/FooterBottom": [
		612,
		9,
		82
	],
	"./webapp/layout/footer/component/desktop/FooterBottom.js": [
		612,
		9,
		82
	],
	"./webapp/layout/footer/component/mobile/Footer": [
		192,
		9
	],
	"./webapp/layout/footer/component/mobile/Footer.js": [
		192,
		9
	],
	"./webapp/layout/footer/component/mobile/FooterLiteApp": [
		379,
		9
	],
	"./webapp/layout/footer/component/mobile/FooterLiteApp.js": [
		379,
		9
	],
	"./webapp/layout/footer/footer.controller": [
		89,
		9
	],
	"./webapp/layout/footer/footer.controller.js": [
		89,
		9
	],
	"./webapp/layout/navbar/component/desktop/navbar": [
		408,
		9
	],
	"./webapp/layout/navbar/component/desktop/navbar.js": [
		408,
		9
	],
	"./webapp/layout/navbar/component/mobile/MyAccountSummary": [
		909,
		9,
		201
	],
	"./webapp/layout/navbar/component/mobile/MyAccountSummary.js": [
		909,
		9,
		201
	],
	"./webapp/layout/navbar/component/mobile/Navbar": [
		418,
		9
	],
	"./webapp/layout/navbar/component/mobile/Navbar.js": [
		418,
		9
	],
	"./webapp/layout/navbar/component/mobile/NavbarMyAccount": [
		932,
		9,
		163
	],
	"./webapp/layout/navbar/component/mobile/NavbarMyAccount.js": [
		932,
		9,
		163
	],
	"./webapp/layout/navbar/navbar.controller": [
		36,
		9
	],
	"./webapp/layout/navbar/navbar.controller.js": [
		36,
		9
	],
	"./webapp/layout/sidemenu/component/FloatingRightSideMenu": [
		506,
		9
	],
	"./webapp/layout/sidemenu/component/FloatingRightSideMenu.js": [
		506,
		9
	],
	"./webapp/layout/sidemenu/sidemenu.controller": [
		115,
		9
	],
	"./webapp/layout/sidemenu/sidemenu.controller.js": [
		115,
		9
	],
	"./webapp/main-route": [
		406,
		9
	],
	"./webapp/main-route.js": [
		406,
		9
	],
	"./webapp/portal/about-us/about-us.controller": [
		831,
		9,
		202
	],
	"./webapp/portal/about-us/about-us.controller.js": [
		831,
		9,
		202
	],
	"./webapp/portal/about-us/about-us.selector": [
		640,
		9,
		71
	],
	"./webapp/portal/about-us/about-us.selector.js": [
		640,
		9,
		71
	],
	"./webapp/portal/about-us/component/about-us": [
		890,
		9,
		164
	],
	"./webapp/portal/about-us/component/about-us.js": [
		890,
		9,
		164
	],
	"./webapp/portal/change-language/change-language.controller": [
		835,
		9,
		203
	],
	"./webapp/portal/change-language/change-language.controller.js": [
		835,
		9,
		203
	],
	"./webapp/portal/change-language/change-language.selector": [
		654,
		9,
		59
	],
	"./webapp/portal/change-language/change-language.selector.js": [
		654,
		9,
		59
	],
	"./webapp/portal/change-language/component/m-change-language": [
		900,
		9,
		118
	],
	"./webapp/portal/change-language/component/m-change-language.js": [
		900,
		9,
		118
	],
	"./webapp/portal/download/desktop/Download": [
		867,
		9,
		0,
		130
	],
	"./webapp/portal/download/desktop/Download.js": [
		867,
		9,
		0,
		130
	],
	"./webapp/portal/download/desktop/DownloadPanel": [
		788,
		9,
		0,
		165
	],
	"./webapp/portal/download/desktop/DownloadPanel.js": [
		788,
		9,
		0,
		165
	],
	"./webapp/portal/download/download.controller": [
		780,
		9,
		204
	],
	"./webapp/portal/download/download.controller.js": [
		780,
		9,
		204
	],
	"./webapp/portal/download/download.selector": [
		626,
		9,
		0,
		50
	],
	"./webapp/portal/download/download.selector.js": [
		626,
		9,
		0,
		50
	],
	"./webapp/portal/download/mobile": [
		533,
		9,
		0,
		30
	],
	"./webapp/portal/download/mobile/": [
		533,
		9,
		0,
		30
	],
	"./webapp/portal/download/mobile/index": [
		533,
		9,
		0,
		30
	],
	"./webapp/portal/download/mobile/index.js": [
		533,
		9,
		0,
		30
	],
	"./webapp/portal/faq/component/faq": [
		891,
		9,
		166
	],
	"./webapp/portal/faq/component/faq.js": [
		891,
		9,
		166
	],
	"./webapp/portal/faq/faq.controller": [
		832,
		9,
		205
	],
	"./webapp/portal/faq/faq.controller.js": [
		832,
		9,
		205
	],
	"./webapp/portal/faq/faq.selector": [
		641,
		9,
		72
	],
	"./webapp/portal/faq/faq.selector.js": [
		641,
		9,
		72
	],
	"./webapp/portal/favourite/MyCollection": [
		791,
		9,
		4,
		154
	],
	"./webapp/portal/favourite/MyCollection.js": [
		791,
		9,
		4,
		154
	],
	"./webapp/portal/favourite/desktop/Favourite": [
		885,
		9,
		4,
		2,
		103
	],
	"./webapp/portal/favourite/desktop/Favourite.js": [
		885,
		9,
		4,
		2,
		103
	],
	"./webapp/portal/favourite/favourite.controller": [
		793,
		9,
		206
	],
	"./webapp/portal/favourite/favourite.controller.js": [
		793,
		9,
		206
	],
	"./webapp/portal/favourite/favourite.selector": [
		638,
		9,
		4,
		2,
		43
	],
	"./webapp/portal/favourite/favourite.selector.js": [
		638,
		9,
		4,
		2,
		43
	],
	"./webapp/portal/favourite/mobile": [
		544,
		9,
		4,
		2,
		24
	],
	"./webapp/portal/favourite/mobile/": [
		544,
		9,
		4,
		2,
		24
	],
	"./webapp/portal/favourite/mobile/index": [
		544,
		9,
		4,
		2,
		24
	],
	"./webapp/portal/favourite/mobile/index.js": [
		544,
		9,
		4,
		2,
		24
	],
	"./webapp/portal/home/desktop/Ad": [
		849,
		9,
		83
	],
	"./webapp/portal/home/desktop/Ad.js": [
		849,
		9,
		83
	],
	"./webapp/portal/home/desktop/AppDownload": [
		910,
		9,
		0,
		131
	],
	"./webapp/portal/home/desktop/AppDownload.js": [
		910,
		9,
		0,
		131
	],
	"./webapp/portal/home/desktop/Banner": [
		838,
		9,
		0,
		167
	],
	"./webapp/portal/home/desktop/Banner.js": [
		838,
		9,
		0,
		167
	],
	"./webapp/portal/home/desktop/Donotmiss": [
		792,
		9,
		207
	],
	"./webapp/portal/home/desktop/Donotmiss.js": [
		792,
		9,
		207
	],
	"./webapp/portal/home/desktop/DroppingHot": [
		801,
		9,
		2,
		200
	],
	"./webapp/portal/home/desktop/DroppingHot.js": [
		801,
		9,
		2,
		200
	],
	"./webapp/portal/home/desktop/Home": [
		667,
		9,
		0,
		18,
		58
	],
	"./webapp/portal/home/desktop/Home.js": [
		667,
		9,
		0,
		18,
		58
	],
	"./webapp/portal/home/desktop/Instruction": [
		786,
		9,
		208
	],
	"./webapp/portal/home/desktop/Instruction.js": [
		786,
		9,
		208
	],
	"./webapp/portal/home/desktop/PromoteSectionBanner": [
		843,
		9,
		0,
		132
	],
	"./webapp/portal/home/desktop/PromoteSectionBanner.js": [
		843,
		9,
		0,
		132
	],
	"./webapp/portal/home/desktop/SidePopup": [
		933,
		9,
		99
	],
	"./webapp/portal/home/desktop/SidePopup.js": [
		933,
		9,
		99
	],
	"./webapp/portal/home/desktop/Sports": [
		925,
		9,
		0,
		18
	],
	"./webapp/portal/home/desktop/Sports.js": [
		925,
		9,
		0,
		18
	],
	"./webapp/portal/home/desktop/TopWinner": [
		850,
		9,
		84
	],
	"./webapp/portal/home/desktop/TopWinner.js": [
		850,
		9,
		84
	],
	"./webapp/portal/home/desktop/context": [
		806,
		9,
		152
	],
	"./webapp/portal/home/desktop/context.js": [
		806,
		9,
		152
	],
	"./webapp/portal/home/desktop/sidepopup/Chat": [
		911,
		9,
		209
	],
	"./webapp/portal/home/desktop/sidepopup/Chat.js": [
		911,
		9,
		209
	],
	"./webapp/portal/home/desktop/sidepopup/ContactUs": [
		912,
		9,
		210
	],
	"./webapp/portal/home/desktop/sidepopup/ContactUs.js": [
		912,
		9,
		210
	],
	"./webapp/portal/home/desktop/sidepopup/Language": [
		913,
		9,
		125
	],
	"./webapp/portal/home/desktop/sidepopup/Language.js": [
		913,
		9,
		125
	],
	"./webapp/portal/home/desktop/sports/Contact": [
		922,
		9,
		211
	],
	"./webapp/portal/home/desktop/sports/Contact.js": [
		922,
		9,
		211
	],
	"./webapp/portal/home/desktop/sports/SportsGames": [
		839,
		9,
		0,
		133
	],
	"./webapp/portal/home/desktop/sports/SportsGames.js": [
		839,
		9,
		0,
		133
	],
	"./webapp/portal/home/desktop/sports/Steps": [
		905,
		9,
		212
	],
	"./webapp/portal/home/desktop/sports/Steps.js": [
		905,
		9,
		212
	],
	"./webapp/portal/home/desktop/sports/UPEvents": [
		840,
		9,
		0,
		134
	],
	"./webapp/portal/home/desktop/sports/UPEvents.js": [
		840,
		9,
		0,
		134
	],
	"./webapp/portal/home/home.controller": [
		841,
		9,
		155
	],
	"./webapp/portal/home/home.controller.js": [
		841,
		9,
		155
	],
	"./webapp/portal/home/home.selector": [
		220,
		9
	],
	"./webapp/portal/home/home.selector.js": [
		220,
		9
	],
	"./webapp/portal/home/mobile": [
		323,
		9,
		0,
		2,
		17
	],
	"./webapp/portal/home/mobile/": [
		323,
		9,
		0,
		2,
		17
	],
	"./webapp/portal/home/mobile/AppDownload": [
		906,
		9,
		168
	],
	"./webapp/portal/home/mobile/AppDownload.js": [
		906,
		9,
		168
	],
	"./webapp/portal/home/mobile/index": [
		323,
		9,
		0,
		2,
		17
	],
	"./webapp/portal/home/mobile/index.js": [
		323,
		9,
		0,
		2,
		17
	],
	"./webapp/portal/leaderboard/leaderboard": [
		927,
		9,
		13,
		78
	],
	"./webapp/portal/leaderboard/leaderboard.controller": [
		914,
		9,
		13
	],
	"./webapp/portal/leaderboard/leaderboard.controller.js": [
		914,
		9,
		13
	],
	"./webapp/portal/leaderboard/leaderboard.js": [
		927,
		9,
		13,
		78
	],
	"./webapp/portal/leaderboard/leaderboard.selector": [
		645,
		9,
		85
	],
	"./webapp/portal/leaderboard/leaderboard.selector.js": [
		645,
		9,
		85
	],
	"./webapp/portal/leaderboard/sub-component/reward-popup/component/reward-popup": [
		844,
		9,
		213
	],
	"./webapp/portal/leaderboard/sub-component/reward-popup/component/reward-popup.js": [
		844,
		9,
		213
	],
	"./webapp/portal/leaderboard/sub-component/reward-popup/reward-popup.selector": [
		934,
		9,
		169
	],
	"./webapp/portal/leaderboard/sub-component/reward-popup/reward-popup.selector.js": [
		934,
		9,
		169
	],
	"./webapp/portal/leaderboard/sub-component/shared/dateTime/component/dateTime": [
		926,
		9,
		13
	],
	"./webapp/portal/leaderboard/sub-component/shared/dateTime/component/dateTime.js": [
		926,
		9,
		13
	],
	"./webapp/portal/leaderboard/sub-component/shared/leaderboard-rank-score/component/leaderboard-rank-score": [
		414,
		9
	],
	"./webapp/portal/leaderboard/sub-component/shared/leaderboard-rank-score/component/leaderboard-rank-score.js": [
		414,
		9
	],
	"./webapp/portal/login/desktop/FloatingLogin": [
		411,
		9
	],
	"./webapp/portal/login/desktop/FloatingLogin.js": [
		411,
		9
	],
	"./webapp/portal/login/login.controller": [
		64,
		9
	],
	"./webapp/portal/login/login.controller.js": [
		64,
		9
	],
	"./webapp/portal/login/mobile/Login": [
		508,
		9
	],
	"./webapp/portal/login/mobile/Login.js": [
		508,
		9
	],
	"./webapp/portal/login/mobile/LoginLanding": [
		656,
		9,
		86
	],
	"./webapp/portal/login/mobile/LoginLanding.js": [
		656,
		9,
		86
	],
	"./webapp/portal/molecules/bank-icon": [
		935,
		7,
		214
	],
	"./webapp/portal/molecules/bank-icon.js": [
		935,
		7,
		214
	],
	"./webapp/portal/news-letter/news-letter-popup": [
		242,
		9
	],
	"./webapp/portal/news-letter/news-letter-popup.js": [
		242,
		9
	],
	"./webapp/portal/news-letter/news-letter.controller": [
		218,
		9
	],
	"./webapp/portal/news-letter/news-letter.controller.js": [
		218,
		9
	],
	"./webapp/portal/promos/desktop/Promos": [
		886,
		9,
		0,
		5,
		215
	],
	"./webapp/portal/promos/desktop/Promos.js": [
		886,
		9,
		0,
		5,
		215
	],
	"./webapp/portal/promos/desktop/PromosPanel": [
		824,
		9,
		0,
		5
	],
	"./webapp/portal/promos/desktop/PromosPanel.js": [
		824,
		9,
		0,
		5
	],
	"./webapp/portal/promos/desktop/promotion.apply": [
		827,
		9,
		216
	],
	"./webapp/portal/promos/desktop/promotion.apply.js": [
		827,
		9,
		216
	],
	"./webapp/portal/promos/desktop/promotion.details": [
		825,
		9,
		217
	],
	"./webapp/portal/promos/desktop/promotion.details.js": [
		825,
		9,
		217
	],
	"./webapp/portal/promos/desktop/promotion.transfer": [
		829,
		9,
		218
	],
	"./webapp/portal/promos/desktop/promotion.transfer.js": [
		829,
		9,
		218
	],
	"./webapp/portal/promos/mobile": [
		545,
		9,
		0,
		5,
		33
	],
	"./webapp/portal/promos/mobile/": [
		545,
		9,
		0,
		5,
		33
	],
	"./webapp/portal/promos/mobile/index": [
		545,
		9,
		0,
		5,
		33
	],
	"./webapp/portal/promos/mobile/index.js": [
		545,
		9,
		0,
		5,
		33
	],
	"./webapp/portal/promos/mobile/promotion.apply": [
		828,
		9,
		219
	],
	"./webapp/portal/promos/mobile/promotion.apply.js": [
		828,
		9,
		219
	],
	"./webapp/portal/promos/mobile/promotion.details": [
		826,
		9,
		220
	],
	"./webapp/portal/promos/mobile/promotion.details.js": [
		826,
		9,
		220
	],
	"./webapp/portal/promos/mobile/promotion.transfer": [
		830,
		9,
		221
	],
	"./webapp/portal/promos/mobile/promotion.transfer.js": [
		830,
		9,
		221
	],
	"./webapp/portal/promos/promotion.controller": [
		547,
		9
	],
	"./webapp/portal/promos/promotion.controller.js": [
		547,
		9
	],
	"./webapp/portal/promos/promotion.selector": [
		639,
		9,
		0,
		5,
		60
	],
	"./webapp/portal/promos/promotion.selector.js": [
		639,
		9,
		0,
		5,
		60
	],
	"./webapp/portal/promos/promotionApply.selector": [
		888,
		9,
		135
	],
	"./webapp/portal/promos/promotionApply.selector.js": [
		888,
		9,
		135
	],
	"./webapp/portal/promos/promotionDetails.selector": [
		887,
		9,
		136
	],
	"./webapp/portal/promos/promotionDetails.selector.js": [
		887,
		9,
		136
	],
	"./webapp/portal/promos/promotionTransfer.selector": [
		889,
		9,
		137
	],
	"./webapp/portal/promos/promotionTransfer.selector.js": [
		889,
		9,
		137
	],
	"./webapp/portal/provider/4d/4d.controller": [
		790,
		9,
		0,
		126
	],
	"./webapp/portal/provider/4d/4d.controller.js": [
		790,
		9,
		0,
		126
	],
	"./webapp/portal/provider/4d/4d.selector": [
		635,
		9,
		0,
		11,
		54
	],
	"./webapp/portal/provider/4d/4d.selector.js": [
		635,
		9,
		0,
		11,
		54
	],
	"./webapp/portal/provider/4d/desktop/FourD": [
		880,
		9,
		0,
		11,
		222
	],
	"./webapp/portal/provider/4d/desktop/FourD.js": [
		880,
		9,
		0,
		11,
		222
	],
	"./webapp/portal/provider/4d/desktop/FourDPanel": [
		881,
		9,
		0,
		11
	],
	"./webapp/portal/provider/4d/desktop/FourDPanel.js": [
		881,
		9,
		0,
		11
	],
	"./webapp/portal/provider/4d/mobile": [
		541,
		9,
		0,
		20
	],
	"./webapp/portal/provider/4d/mobile/": [
		541,
		9,
		0,
		20
	],
	"./webapp/portal/provider/4d/mobile/SubGameMenu": [
		653,
		9,
		0,
		57
	],
	"./webapp/portal/provider/4d/mobile/SubGameMenu.js": [
		653,
		9,
		0,
		57
	],
	"./webapp/portal/provider/4d/mobile/index": [
		541,
		9,
		0,
		20
	],
	"./webapp/portal/provider/4d/mobile/index.js": [
		541,
		9,
		0,
		20
	],
	"./webapp/portal/provider/casino/casino.controller": [
		805,
		9,
		156
	],
	"./webapp/portal/provider/casino/casino.controller.js": [
		805,
		9,
		156
	],
	"./webapp/portal/provider/casino/casino.selector": [
		627,
		9,
		0,
		12,
		55
	],
	"./webapp/portal/provider/casino/casino.selector.js": [
		627,
		9,
		0,
		12,
		55
	],
	"./webapp/portal/provider/casino/desktop/Casino": [
		868,
		9,
		0,
		12,
		223
	],
	"./webapp/portal/provider/casino/desktop/Casino.js": [
		868,
		9,
		0,
		12,
		223
	],
	"./webapp/portal/provider/casino/desktop/CasinoPanel": [
		869,
		9,
		0,
		12
	],
	"./webapp/portal/provider/casino/desktop/CasinoPanel.js": [
		869,
		9,
		0,
		12
	],
	"./webapp/portal/provider/casino/mobile": [
		534,
		9,
		0,
		26
	],
	"./webapp/portal/provider/casino/mobile/": [
		534,
		9,
		0,
		26
	],
	"./webapp/portal/provider/casino/mobile/index": [
		534,
		9,
		0,
		26
	],
	"./webapp/portal/provider/casino/mobile/index.js": [
		534,
		9,
		0,
		26
	],
	"./webapp/portal/provider/cockfight/cockfight.controller": [
		778,
		9,
		157
	],
	"./webapp/portal/provider/cockfight/cockfight.controller.js": [
		778,
		9,
		157
	],
	"./webapp/portal/provider/cockfight/cockfight.selector": [
		637,
		9,
		0,
		39
	],
	"./webapp/portal/provider/cockfight/cockfight.selector.js": [
		637,
		9,
		0,
		39
	],
	"./webapp/portal/provider/cockfight/desktop/Cockfight": [
		884,
		9,
		0,
		104
	],
	"./webapp/portal/provider/cockfight/desktop/Cockfight.js": [
		884,
		9,
		0,
		104
	],
	"./webapp/portal/provider/cockfight/desktop/CockfightPanel": [
		823,
		9,
		0,
		114
	],
	"./webapp/portal/provider/cockfight/desktop/CockfightPanel.js": [
		823,
		9,
		0,
		114
	],
	"./webapp/portal/provider/cockfight/mobile": [
		543,
		9,
		0,
		27
	],
	"./webapp/portal/provider/cockfight/mobile/": [
		543,
		9,
		0,
		27
	],
	"./webapp/portal/provider/cockfight/mobile/index": [
		543,
		9,
		0,
		27
	],
	"./webapp/portal/provider/cockfight/mobile/index.js": [
		543,
		9,
		0,
		27
	],
	"./webapp/portal/provider/e-sports/desktop/Esports": [
		874,
		9,
		0,
		105
	],
	"./webapp/portal/provider/e-sports/desktop/Esports.js": [
		874,
		9,
		0,
		105
	],
	"./webapp/portal/provider/e-sports/desktop/EsportsPanel": [
		817,
		9,
		0,
		115
	],
	"./webapp/portal/provider/e-sports/desktop/EsportsPanel.js": [
		817,
		9,
		0,
		115
	],
	"./webapp/portal/provider/e-sports/e-sports.controller": [
		776,
		9,
		158
	],
	"./webapp/portal/provider/e-sports/e-sports.controller.js": [
		776,
		9,
		158
	],
	"./webapp/portal/provider/e-sports/e-sports.selector": [
		630,
		9,
		0,
		40
	],
	"./webapp/portal/provider/e-sports/e-sports.selector.js": [
		630,
		9,
		0,
		40
	],
	"./webapp/portal/provider/e-sports/mobile": [
		537,
		9,
		0,
		28
	],
	"./webapp/portal/provider/e-sports/mobile/": [
		537,
		9,
		0,
		28
	],
	"./webapp/portal/provider/e-sports/mobile/index": [
		537,
		9,
		0,
		28
	],
	"./webapp/portal/provider/e-sports/mobile/index.js": [
		537,
		9,
		0,
		28
	],
	"./webapp/portal/provider/fast-games-1/desktop/fast-games": [
		882,
		9,
		0,
		10,
		170
	],
	"./webapp/portal/provider/fast-games-1/desktop/fast-games-banner": [
		822,
		9,
		0,
		224
	],
	"./webapp/portal/provider/fast-games-1/desktop/fast-games-banner.js": [
		822,
		9,
		0,
		224
	],
	"./webapp/portal/provider/fast-games-1/desktop/fast-games-games": [
		883,
		9,
		0,
		10
	],
	"./webapp/portal/provider/fast-games-1/desktop/fast-games-games.js": [
		883,
		9,
		0,
		10
	],
	"./webapp/portal/provider/fast-games-1/desktop/fast-games.js": [
		882,
		9,
		0,
		10,
		170
	],
	"./webapp/portal/provider/fast-games-1/fast-games-detail.controller": [
		899,
		9,
		0,
		112
	],
	"./webapp/portal/provider/fast-games-1/fast-games-detail.controller.js": [
		899,
		9,
		0,
		112
	],
	"./webapp/portal/provider/fast-games-1/fast-games.controller": [
		772,
		9,
		0,
		127
	],
	"./webapp/portal/provider/fast-games-1/fast-games.controller.js": [
		772,
		9,
		0,
		127
	],
	"./webapp/portal/provider/fast-games-1/fast-games.selector": [
		636,
		9,
		0,
		10,
		51
	],
	"./webapp/portal/provider/fast-games-1/fast-games.selector.js": [
		636,
		9,
		0,
		10,
		51
	],
	"./webapp/portal/provider/fast-games-1/mobile": [
		542,
		9,
		0,
		21
	],
	"./webapp/portal/provider/fast-games-1/mobile/": [
		542,
		9,
		0,
		21
	],
	"./webapp/portal/provider/fast-games-1/mobile/SubGameMenu": [
		652,
		9,
		0,
		37
	],
	"./webapp/portal/provider/fast-games-1/mobile/SubGameMenu.js": [
		652,
		9,
		0,
		37
	],
	"./webapp/portal/provider/fast-games-1/mobile/index": [
		542,
		9,
		0,
		21
	],
	"./webapp/portal/provider/fast-games-1/mobile/index.js": [
		542,
		9,
		0,
		21
	],
	"./webapp/portal/provider/fishing/desktop/Fishing": [
		877,
		9,
		0,
		1,
		107
	],
	"./webapp/portal/provider/fishing/desktop/Fishing.js": [
		877,
		9,
		0,
		1,
		107
	],
	"./webapp/portal/provider/fishing/desktop/FishingPanel": [
		936,
		9,
		0,
		1,
		171
	],
	"./webapp/portal/provider/fishing/desktop/FishingPanel.js": [
		936,
		9,
		0,
		1,
		171
	],
	"./webapp/portal/provider/fishing/desktop/FishingPanel02": [
		818,
		9,
		0,
		1,
		119
	],
	"./webapp/portal/provider/fishing/desktop/FishingPanel02.js": [
		818,
		9,
		0,
		1,
		119
	],
	"./webapp/portal/provider/fishing/desktop/components/FishingBanner": [
		798,
		9,
		0,
		225
	],
	"./webapp/portal/provider/fishing/desktop/components/FishingBanner.js": [
		798,
		9,
		0,
		225
	],
	"./webapp/portal/provider/fishing/desktop/components/FishingGames": [
		799,
		9,
		0,
		1,
		172
	],
	"./webapp/portal/provider/fishing/desktop/components/FishingGames.js": [
		799,
		9,
		0,
		1,
		172
	],
	"./webapp/portal/provider/fishing/fishing.controller": [
		784,
		9,
		0,
		1
	],
	"./webapp/portal/provider/fishing/fishing.controller.js": [
		784,
		9,
		0,
		1
	],
	"./webapp/portal/provider/fishing/fishing.selector": [
		632,
		9,
		0,
		1,
		42
	],
	"./webapp/portal/provider/fishing/fishing.selector.js": [
		632,
		9,
		0,
		1,
		42
	],
	"./webapp/portal/provider/fishing/mobile": [
		538,
		9,
		0,
		1,
		31
	],
	"./webapp/portal/provider/fishing/mobile/": [
		538,
		9,
		0,
		1,
		31
	],
	"./webapp/portal/provider/fishing/mobile/SubGameMenu": [
		650,
		9,
		0,
		1,
		66
	],
	"./webapp/portal/provider/fishing/mobile/SubGameMenu.js": [
		650,
		9,
		0,
		1,
		66
	],
	"./webapp/portal/provider/fishing/mobile/index": [
		538,
		9,
		0,
		1,
		31
	],
	"./webapp/portal/provider/fishing/mobile/index.js": [
		538,
		9,
		0,
		1,
		31
	],
	"./webapp/portal/provider/games-3d/desktop/Games-3D": [
		879,
		9,
		0,
		98
	],
	"./webapp/portal/provider/games-3d/desktop/Games-3D-Banner": [
		820,
		9,
		0,
		226
	],
	"./webapp/portal/provider/games-3d/desktop/Games-3D-Banner.js": [
		820,
		9,
		0,
		226
	],
	"./webapp/portal/provider/games-3d/desktop/Games-3D-Games": [
		821,
		9,
		0,
		101
	],
	"./webapp/portal/provider/games-3d/desktop/Games-3D-Games.js": [
		821,
		9,
		0,
		101
	],
	"./webapp/portal/provider/games-3d/desktop/Games-3D.js": [
		879,
		9,
		0,
		98
	],
	"./webapp/portal/provider/games-3d/games-3d.controller": [
		764,
		9,
		0,
		153
	],
	"./webapp/portal/provider/games-3d/games-3d.controller.js": [
		764,
		9,
		0,
		153
	],
	"./webapp/portal/provider/games-3d/games-3d.selector": [
		634,
		9,
		0,
		38
	],
	"./webapp/portal/provider/games-3d/games-3d.selector.js": [
		634,
		9,
		0,
		38
	],
	"./webapp/portal/provider/games-3d/mobile": [
		540,
		9,
		0,
		25
	],
	"./webapp/portal/provider/games-3d/mobile/": [
		540,
		9,
		0,
		25
	],
	"./webapp/portal/provider/games-3d/mobile/SubGameMenu": [
		649,
		9,
		0,
		48
	],
	"./webapp/portal/provider/games-3d/mobile/SubGameMenu.js": [
		649,
		9,
		0,
		48
	],
	"./webapp/portal/provider/games-3d/mobile/index": [
		540,
		9,
		0,
		25
	],
	"./webapp/portal/provider/games-3d/mobile/index.js": [
		540,
		9,
		0,
		25
	],
	"./webapp/portal/provider/lottery/desktop/Lottery": [
		878,
		9,
		0,
		7,
		138
	],
	"./webapp/portal/provider/lottery/desktop/Lottery.js": [
		878,
		9,
		0,
		7,
		138
	],
	"./webapp/portal/provider/lottery/desktop/LotteryPanel": [
		937,
		9,
		0,
		102
	],
	"./webapp/portal/provider/lottery/desktop/LotteryPanel.js": [
		937,
		9,
		0,
		102
	],
	"./webapp/portal/provider/lottery/desktop/LotteryPanel02": [
		819,
		9,
		0,
		7,
		173
	],
	"./webapp/portal/provider/lottery/desktop/LotteryPanel02.js": [
		819,
		9,
		0,
		7,
		173
	],
	"./webapp/portal/provider/lottery/desktop/components/LotteryBanner": [
		800,
		9,
		0,
		227
	],
	"./webapp/portal/provider/lottery/desktop/components/LotteryBanner.js": [
		800,
		9,
		0,
		227
	],
	"./webapp/portal/provider/lottery/desktop/components/LotteryGames": [
		847,
		9,
		0,
		7
	],
	"./webapp/portal/provider/lottery/desktop/components/LotteryGames.js": [
		847,
		9,
		0,
		7
	],
	"./webapp/portal/provider/lottery/lottery.controller": [
		777,
		9,
		0,
		128
	],
	"./webapp/portal/provider/lottery/lottery.controller.js": [
		777,
		9,
		0,
		128
	],
	"./webapp/portal/provider/lottery/lottery.selector": [
		633,
		9,
		0,
		7,
		45
	],
	"./webapp/portal/provider/lottery/lottery.selector.js": [
		633,
		9,
		0,
		7,
		45
	],
	"./webapp/portal/provider/lottery/mobile": [
		539,
		9,
		0,
		22
	],
	"./webapp/portal/provider/lottery/mobile/": [
		539,
		9,
		0,
		22
	],
	"./webapp/portal/provider/lottery/mobile/SubGameMenu": [
		651,
		9,
		0,
		49
	],
	"./webapp/portal/provider/lottery/mobile/SubGameMenu.js": [
		651,
		9,
		0,
		49
	],
	"./webapp/portal/provider/lottery/mobile/index": [
		539,
		9,
		0,
		22
	],
	"./webapp/portal/provider/lottery/mobile/index.js": [
		539,
		9,
		0,
		22
	],
	"./webapp/portal/provider/maintenance/desktop/maintenance": [
		896,
		9,
		174
	],
	"./webapp/portal/provider/maintenance/desktop/maintenance.js": [
		896,
		9,
		174
	],
	"./webapp/portal/provider/maintenance/maintenance.controller": [
		795,
		9,
		228
	],
	"./webapp/portal/provider/maintenance/maintenance.controller.js": [
		795,
		9,
		228
	],
	"./webapp/portal/provider/maintenance/maintenance.selector": [
		647,
		9,
		67
	],
	"./webapp/portal/provider/maintenance/maintenance.selector.js": [
		647,
		9,
		67
	],
	"./webapp/portal/provider/maintenance/mobile": [
		546,
		9,
		34
	],
	"./webapp/portal/provider/maintenance/mobile/": [
		546,
		9,
		34
	],
	"./webapp/portal/provider/maintenance/mobile/index": [
		546,
		9,
		34
	],
	"./webapp/portal/provider/maintenance/mobile/index.js": [
		546,
		9,
		34
	],
	"./webapp/portal/provider/mega/desktop/Mega": [
		768,
		9,
		175
	],
	"./webapp/portal/provider/mega/desktop/Mega.js": [
		768,
		9,
		175
	],
	"./webapp/portal/provider/mega/mega.controller": [
		760,
		9,
		229
	],
	"./webapp/portal/provider/mega/mega.controller.js": [
		760,
		9,
		229
	],
	"./webapp/portal/provider/mega/mega.selector": [
		782,
		9,
		120
	],
	"./webapp/portal/provider/mega/mega.selector.js": [
		782,
		9,
		120
	],
	"./webapp/portal/provider/mega/mobile/Mega": [
		769,
		9,
		176
	],
	"./webapp/portal/provider/mega/mobile/Mega.js": [
		769,
		9,
		176
	],
	"./webapp/portal/provider/poker/desktop/Poker": [
		875,
		9,
		0,
		116
	],
	"./webapp/portal/provider/poker/desktop/Poker.js": [
		875,
		9,
		0,
		116
	],
	"./webapp/portal/provider/poker/mobile/Poker": [
		876,
		9,
		0,
		100
	],
	"./webapp/portal/provider/poker/mobile/Poker.js": [
		876,
		9,
		0,
		100
	],
	"./webapp/portal/provider/poker/poker.controller": [
		789,
		9,
		159
	],
	"./webapp/portal/provider/poker/poker.controller.js": [
		789,
		9,
		159
	],
	"./webapp/portal/provider/poker/poker.selector": [
		631,
		9,
		0,
		44
	],
	"./webapp/portal/provider/poker/poker.selector.js": [
		631,
		9,
		0,
		44
	],
	"./webapp/portal/provider/psy8/desktop/Psy8": [
		770,
		9,
		0,
		139
	],
	"./webapp/portal/provider/psy8/desktop/Psy8.js": [
		770,
		9,
		0,
		139
	],
	"./webapp/portal/provider/psy8/mobile/Psy8": [
		771,
		9,
		0,
		140
	],
	"./webapp/portal/provider/psy8/mobile/Psy8.js": [
		771,
		9,
		0,
		140
	],
	"./webapp/portal/provider/psy8/psy8.controller": [
		761,
		9,
		230
	],
	"./webapp/portal/provider/psy8/psy8.controller.js": [
		761,
		9,
		230
	],
	"./webapp/portal/provider/psy8/psy8.selector": [
		783,
		9,
		0,
		108
	],
	"./webapp/portal/provider/psy8/psy8.selector.js": [
		783,
		9,
		0,
		108
	],
	"./webapp/portal/provider/redirect-error/desktop/redirect-error": [
		863,
		9,
		177
	],
	"./webapp/portal/provider/redirect-error/desktop/redirect-error.js": [
		863,
		9,
		177
	],
	"./webapp/portal/provider/redirect-error/mobile": [
		532,
		9,
		35
	],
	"./webapp/portal/provider/redirect-error/mobile/": [
		532,
		9,
		35
	],
	"./webapp/portal/provider/redirect-error/mobile/index": [
		532,
		9,
		35
	],
	"./webapp/portal/provider/redirect-error/mobile/index.js": [
		532,
		9,
		35
	],
	"./webapp/portal/provider/redirect-error/redirect-error.controller": [
		787,
		9,
		231
	],
	"./webapp/portal/provider/redirect-error/redirect-error.controller.js": [
		787,
		9,
		231
	],
	"./webapp/portal/provider/redirect-error/redirect-error.selector": [
		624,
		9,
		68
	],
	"./webapp/portal/provider/redirect-error/redirect-error.selector.js": [
		624,
		9,
		68
	],
	"./webapp/portal/provider/scr/desktop/Scr": [
		766,
		9,
		0,
		141
	],
	"./webapp/portal/provider/scr/desktop/Scr.js": [
		766,
		9,
		0,
		141
	],
	"./webapp/portal/provider/scr/mobile/Scr": [
		767,
		9,
		0,
		142
	],
	"./webapp/portal/provider/scr/mobile/Scr.js": [
		767,
		9,
		0,
		142
	],
	"./webapp/portal/provider/scr/scr.controller": [
		759,
		9,
		232
	],
	"./webapp/portal/provider/scr/scr.controller.js": [
		759,
		9,
		232
	],
	"./webapp/portal/provider/scr/scr.selector": [
		781,
		9,
		0,
		109
	],
	"./webapp/portal/provider/scr/scr.selector.js": [
		781,
		9,
		0,
		109
	],
	"./webapp/portal/provider/slots/desktop/Slots": [
		870,
		9,
		0,
		9,
		14,
		233
	],
	"./webapp/portal/provider/slots/desktop/Slots.js": [
		870,
		9,
		0,
		9,
		14,
		233
	],
	"./webapp/portal/provider/slots/desktop/SlotsBanner": [
		871,
		9,
		0,
		14
	],
	"./webapp/portal/provider/slots/desktop/SlotsBanner.js": [
		871,
		9,
		0,
		14
	],
	"./webapp/portal/provider/slots/desktop/SlotsGames": [
		872,
		9,
		0,
		9
	],
	"./webapp/portal/provider/slots/desktop/SlotsGames.js": [
		872,
		9,
		0,
		9
	],
	"./webapp/portal/provider/slots/mobile": [
		535,
		9,
		0,
		23
	],
	"./webapp/portal/provider/slots/mobile/": [
		535,
		9,
		0,
		23
	],
	"./webapp/portal/provider/slots/mobile/SubGameMenu": [
		648,
		9,
		0,
		36
	],
	"./webapp/portal/provider/slots/mobile/SubGameMenu.js": [
		648,
		9,
		0,
		36
	],
	"./webapp/portal/provider/slots/mobile/index": [
		535,
		9,
		0,
		23
	],
	"./webapp/portal/provider/slots/mobile/index.js": [
		535,
		9,
		0,
		23
	],
	"./webapp/portal/provider/slots/slot-detail.controller": [
		898,
		9,
		0,
		113
	],
	"./webapp/portal/provider/slots/slot-detail.controller.js": [
		898,
		9,
		0,
		113
	],
	"./webapp/portal/provider/slots/slot.controller": [
		774,
		9,
		0,
		129
	],
	"./webapp/portal/provider/slots/slot.controller.js": [
		774,
		9,
		0,
		129
	],
	"./webapp/portal/provider/slots/slots.selector": [
		628,
		9,
		0,
		9,
		14,
		56
	],
	"./webapp/portal/provider/slots/slots.selector.js": [
		628,
		9,
		0,
		9,
		14,
		56
	],
	"./webapp/portal/provider/sports/desktop/Sports": [
		873,
		9,
		0,
		106
	],
	"./webapp/portal/provider/sports/desktop/Sports.js": [
		873,
		9,
		0,
		106
	],
	"./webapp/portal/provider/sports/desktop/SportsPanel": [
		816,
		9,
		0,
		117
	],
	"./webapp/portal/provider/sports/desktop/SportsPanel.js": [
		816,
		9,
		0,
		117
	],
	"./webapp/portal/provider/sports/mobile": [
		536,
		9,
		0,
		29
	],
	"./webapp/portal/provider/sports/mobile/": [
		536,
		9,
		0,
		29
	],
	"./webapp/portal/provider/sports/mobile/index": [
		536,
		9,
		0,
		29
	],
	"./webapp/portal/provider/sports/mobile/index.js": [
		536,
		9,
		0,
		29
	],
	"./webapp/portal/provider/sports/sports.controller": [
		775,
		9,
		160
	],
	"./webapp/portal/provider/sports/sports.controller.js": [
		775,
		9,
		160
	],
	"./webapp/portal/provider/sports/sports.selector": [
		629,
		9,
		0,
		41
	],
	"./webapp/portal/provider/sports/sports.selector.js": [
		629,
		9,
		0,
		41
	],
	"./webapp/portal/redirect-page/redirect-page": [
		938,
		9,
		234
	],
	"./webapp/portal/redirect-page/redirect-page.js": [
		938,
		9,
		234
	],
	"./webapp/portal/register/desktop/Register": [
		864,
		9,
		6,
		8,
		235
	],
	"./webapp/portal/register/desktop/Register.js": [
		864,
		9,
		6,
		8,
		235
	],
	"./webapp/portal/register/desktop/RegisterPanel": [
		811,
		9,
		6,
		8
	],
	"./webapp/portal/register/desktop/RegisterPanel.js": [
		811,
		9,
		6,
		8
	],
	"./webapp/portal/register/mobile/Register": [
		866,
		9,
		6,
		8,
		236
	],
	"./webapp/portal/register/mobile/Register.js": [
		866,
		9,
		6,
		8,
		236
	],
	"./webapp/portal/register/mobile/RegisterLanding": [
		655,
		9,
		87
	],
	"./webapp/portal/register/mobile/RegisterLanding.js": [
		655,
		9,
		87
	],
	"./webapp/portal/register/register-constants": [
		846,
		9,
		237
	],
	"./webapp/portal/register/register-constants.js": [
		846,
		9,
		237
	],
	"./webapp/portal/register/register.controller": [
		924,
		9,
		6
	],
	"./webapp/portal/register/register.controller.js": [
		924,
		9,
		6
	],
	"./webapp/portal/register/register.selector": [
		625,
		9,
		6,
		8,
		73
	],
	"./webapp/portal/register/register.selector.js": [
		625,
		9,
		6,
		8,
		73
	],
	"./webapp/portal/reset-password/desktop/FloatingResetPassword": [
		413,
		9
	],
	"./webapp/portal/reset-password/desktop/FloatingResetPassword.js": [
		413,
		9
	],
	"./webapp/portal/reset-password/mobile/Reset": [
		509,
		9
	],
	"./webapp/portal/reset-password/mobile/Reset.js": [
		509,
		9
	],
	"./webapp/portal/reset-password/reset-password.controller": [
		109,
		9
	],
	"./webapp/portal/reset-password/reset-password.controller.js": [
		109,
		9
	],
	"./webapp/portal/responsible-gaming/component/responsible-gaming": [
		892,
		9,
		178
	],
	"./webapp/portal/responsible-gaming/component/responsible-gaming.js": [
		892,
		9,
		178
	],
	"./webapp/portal/responsible-gaming/responsible-gaming.controller": [
		833,
		9,
		238
	],
	"./webapp/portal/responsible-gaming/responsible-gaming.controller.js": [
		833,
		9,
		238
	],
	"./webapp/portal/responsible-gaming/responsible-gaming.selector": [
		642,
		9,
		74
	],
	"./webapp/portal/responsible-gaming/responsible-gaming.selector.js": [
		642,
		9,
		74
	],
	"./webapp/portal/settings/add-bank-dialog/add-bank-dialog.controller": [
		155,
		9
	],
	"./webapp/portal/settings/add-bank-dialog/add-bank-dialog.controller.js": [
		155,
		9
	],
	"./webapp/portal/settings/add-bank-dialog/add-bank-dialog.selector": [
		939,
		9,
		143
	],
	"./webapp/portal/settings/add-bank-dialog/add-bank-dialog.selector.js": [
		939,
		9,
		143
	],
	"./webapp/portal/settings/add-bank-dialog/component/add-bank-dialog": [
		915,
		9,
		239
	],
	"./webapp/portal/settings/add-bank-dialog/component/add-bank-dialog.js": [
		915,
		9,
		239
	],
	"./webapp/portal/settings/add-bank-dialog/component/add-bank-dialog_96c": [
		119,
		9
	],
	"./webapp/portal/settings/add-bank-dialog/component/add-bank-dialog_96c.js": [
		119,
		9
	],
	"./webapp/portal/settings/add-bank-dialog/component/m-add-bank-dialog": [
		916,
		9,
		240
	],
	"./webapp/portal/settings/add-bank-dialog/component/m-add-bank-dialog.js": [
		916,
		9,
		240
	],
	"./webapp/portal/settings/bank-detail/bank-detail.controller": [
		27,
		9
	],
	"./webapp/portal/settings/bank-detail/bank-detail.controller.js": [
		27,
		9
	],
	"./webapp/portal/settings/bank-detail/bank-detail.selector": [
		500,
		9
	],
	"./webapp/portal/settings/bank-detail/bank-detail.selector.js": [
		500,
		9
	],
	"./webapp/portal/settings/bank-detail/component/bank-detail.module.scss": [
		599,
		7
	],
	"./webapp/portal/settings/bank-detail/component/desktop/bank-detail": [
		306,
		9
	],
	"./webapp/portal/settings/bank-detail/component/desktop/bank-detail.js": [
		306,
		9
	],
	"./webapp/portal/settings/bank-detail/component/mobile/m-bank-detail": [
		662,
		9,
		88
	],
	"./webapp/portal/settings/bank-detail/component/mobile/m-bank-detail.js": [
		662,
		9,
		88
	],
	"./webapp/portal/settings/change-password/change-password-constant": [
		758,
		9,
		241
	],
	"./webapp/portal/settings/change-password/change-password-constant.js": [
		758,
		9,
		241
	],
	"./webapp/portal/settings/change-password/change-password.controller": [
		763,
		9,
		179
	],
	"./webapp/portal/settings/change-password/change-password.controller.js": [
		763,
		9,
		179
	],
	"./webapp/portal/settings/change-password/change-password.selector": [
		940,
		9,
		121
	],
	"./webapp/portal/settings/change-password/change-password.selector.js": [
		940,
		9,
		121
	],
	"./webapp/portal/settings/change-password/component/desktop/change-password": [
		779,
		9,
		144
	],
	"./webapp/portal/settings/change-password/component/desktop/change-password.js": [
		779,
		9,
		144
	],
	"./webapp/portal/settings/change-password/component/mobile/m-change-password": [
		855,
		9,
		122
	],
	"./webapp/portal/settings/change-password/component/mobile/m-change-password.js": [
		855,
		9,
		122
	],
	"./webapp/portal/settings/change-provider-password/change-provider-password.controller": [
		765,
		9,
		242
	],
	"./webapp/portal/settings/change-provider-password/change-provider-password.controller.js": [
		765,
		9,
		242
	],
	"./webapp/portal/settings/change-provider-password/change-provider-password.selector": [
		941,
		9,
		145
	],
	"./webapp/portal/settings/change-provider-password/change-provider-password.selector.js": [
		941,
		9,
		145
	],
	"./webapp/portal/settings/change-provider-password/component/desktop/change-provider-password": [
		808,
		9,
		180
	],
	"./webapp/portal/settings/change-provider-password/component/desktop/change-provider-password.js": [
		808,
		9,
		180
	],
	"./webapp/portal/settings/change-provider-password/component/mobile/m-change-provider-password": [
		856,
		9,
		181
	],
	"./webapp/portal/settings/change-provider-password/component/mobile/m-change-provider-password.js": [
		856,
		9,
		181
	],
	"./webapp/portal/settings/delete-bank-dialog/component/delete-bank-dialog": [
		501,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/component/delete-bank-dialog.js": [
		501,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/component/m-delete-bank-dialog": [
		502,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/component/m-delete-bank-dialog.js": [
		502,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/delete-bank-dialog.controller": [
		198,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/delete-bank-dialog.controller.js": [
		198,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/delete-bank-dialog.selector": [
		286,
		9
	],
	"./webapp/portal/settings/delete-bank-dialog/delete-bank-dialog.selector.js": [
		286,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/component/delete-message-dialog": [
		496,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/component/delete-message-dialog.js": [
		496,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/component/m-delete-message-dialog": [
		497,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/component/m-delete-message-dialog.js": [
		497,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/delete-message-dialog.controller": [
		197,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/delete-message-dialog.controller.js": [
		197,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/delete-message-dialog.selector": [
		376,
		9
	],
	"./webapp/portal/settings/delete-message-dialog/delete-message-dialog.selector.js": [
		376,
		9
	],
	"./webapp/portal/settings/deposit/component/desktop/deposit": [
		294,
		9
	],
	"./webapp/portal/settings/deposit/component/desktop/deposit.js": [
		294,
		9
	],
	"./webapp/portal/settings/deposit/component/mobile/m-deposit": [
		510,
		9
	],
	"./webapp/portal/settings/deposit/component/mobile/m-deposit.js": [
		510,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/component/desktop/deposit-landing": [
		421,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/component/desktop/deposit-landing.js": [
		421,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/component/mobile/deposit-landing": [
		459,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/component/mobile/deposit-landing.js": [
		459,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/deposit-landing.controller": [
		81,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/deposit-landing.controller.js": [
		81,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/deposit-landing.selector": [
		245,
		9
	],
	"./webapp/portal/settings/deposit/deposit-landing/deposit-landing.selector.js": [
		245,
		9
	],
	"./webapp/portal/settings/deposit/deposit-util": [
		60,
		9
	],
	"./webapp/portal/settings/deposit/deposit-util.js": [
		60,
		9
	],
	"./webapp/portal/settings/deposit/deposit.controller": [
		16,
		9
	],
	"./webapp/portal/settings/deposit/deposit.controller.js": [
		16,
		9
	],
	"./webapp/portal/settings/deposit/deposit.selector": [
		420,
		9
	],
	"./webapp/portal/settings/deposit/deposit.selector.js": [
		420,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/bank-apps.controller": [
		61,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/bank-apps.controller.js": [
		61,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/bank-apps.selector": [
		438,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/bank-apps.selector.js": [
		438,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/component/desktop/bank-apps": [
		439,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/component/desktop/bank-apps.js": [
		439,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/component/mobile/bank-apps": [
		440,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-apps/component/mobile/bank-apps.js": [
		440,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/bank-qr-deposit.controller": [
		90,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/bank-qr-deposit.controller.js": [
		90,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/bank-qr-deposit.selector": [
		450,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/bank-qr-deposit.selector.js": [
		450,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/component/desktop/bank-qr-deposit": [
		451,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/component/desktop/bank-qr-deposit.js": [
		451,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/component/mobile/m-bank-qr-deposit": [
		452,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-qr-deposit/component/mobile/m-bank-qr-deposit.js": [
		452,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/bank-transfer.controller": [
		56,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/bank-transfer.controller.js": [
		56,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/bank-transfer.selector": [
		423,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/bank-transfer.selector.js": [
		423,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/component/desktop/bank-transfer": [
		424,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/component/desktop/bank-transfer.js": [
		424,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/component/mobile/bank-transfer": [
		426,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/bank-transfer/component/mobile/bank-transfer.js": [
		426,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/component/desktop/crypto": [
		246,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/component/desktop/crypto.js": [
		246,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/component/mobile/crypto": [
		428,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/component/mobile/crypto.js": [
		428,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/crypto.controller": [
		30,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/crypto.controller.js": [
		30,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/crypto.selector": [
		427,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/crypto/crypto.selector.js": [
		427,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/component/desktop/ewallet-apps": [
		454,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/component/desktop/ewallet-apps.js": [
		454,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/component/mobile/ewallet-apps": [
		455,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/component/mobile/ewallet-apps.js": [
		455,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/ewallet-apps.controller": [
		71,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/ewallet-apps.controller.js": [
		71,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/ewallet-apps.selector": [
		453,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/ewallet-apps/ewallet-apps.selector.js": [
		453,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/component/desktop/express-deposit": [
		442,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/component/desktop/express-deposit.js": [
		442,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/component/mobile/express-deposit": [
		443,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/component/mobile/express-deposit.js": [
		443,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/express-deposit.controller": [
		70,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/express-deposit.controller.js": [
		70,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/express-deposit.selector": [
		441,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/express-deposit/express-deposit.selector.js": [
		441,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/component/desktop/mobile-card-deposit": [
		448,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/component/desktop/mobile-card-deposit.js": [
		448,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/component/mobile/m-mobile-card-deposit": [
		449,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/component/mobile/m-mobile-card-deposit.js": [
		449,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/mobile-card-deposit.controller": [
		114,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/mobile-card-deposit.controller.js": [
		114,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/mobile-card-deposit.selector": [
		447,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/mobile-card-deposit/mobile-card-deposit.selector.js": [
		447,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/component/desktop/p2p-deposit": [
		445,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/component/desktop/p2p-deposit.js": [
		445,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/component/mobile/p2p-deposit": [
		446,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/component/mobile/p2p-deposit.js": [
		446,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/p2p-deposit.controller": [
		95,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/p2p-deposit.controller.js": [
		95,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/p2p-deposit.selector": [
		444,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/p2p-deposit/p2p-deposit.selector.js": [
		444,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/component/desktop/qrcode-pay": [
		433,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/component/desktop/qrcode-pay.js": [
		433,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/component/mobile/qrcode-pay": [
		434,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/component/mobile/qrcode-pay.js": [
		434,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/qrcode-pay.controller": [
		69,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/qrcode-pay.controller.js": [
		69,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/qrcode-pay.selector": [
		432,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/qrcode-pay/qrcode-pay.selector.js": [
		432,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/component/desktop/quick-pay": [
		430,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/component/desktop/quick-pay.js": [
		430,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/component/mobile/quick-pay": [
		431,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/component/mobile/quick-pay.js": [
		431,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/quick-pay.controller": [
		94,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/quick-pay.controller.js": [
		94,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/quick-pay.selector": [
		429,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/quick-pay/quick-pay.selector.js": [
		429,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/component/desktop/region-qr": [
		457,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/component/desktop/region-qr.js": [
		457,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/component/mobile/region-qr": [
		458,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/component/mobile/region-qr.js": [
		458,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/region-qr.controller": [
		44,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/region-qr.controller.js": [
		44,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/region-qr.selector": [
		456,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/region-qr/region-qr.selector.js": [
		456,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/component/desktop/reload": [
		436,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/component/desktop/reload.js": [
		436,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/component/mobile/reload": [
		437,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/component/mobile/reload.js": [
		437,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/reload.controller": [
		76,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/reload.controller.js": [
		76,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/reload.selector": [
		435,
		9
	],
	"./webapp/portal/settings/deposit/sub-component/reload/reload.selector.js": [
		435,
		9
	],
	"./webapp/portal/settings/history/component/betting-summary/hybrid/betting-summary": [
		488,
		9
	],
	"./webapp/portal/settings/history/component/betting-summary/hybrid/betting-summary.js": [
		488,
		9
	],
	"./webapp/portal/settings/history/component/betting-summary/useBettingSummary": [
		489,
		9
	],
	"./webapp/portal/settings/history/component/betting-summary/useBettingSummary.js": [
		489,
		9
	],
	"./webapp/portal/settings/history/component/desktop/history-landing": [
		303,
		9
	],
	"./webapp/portal/settings/history/component/desktop/history-landing.js": [
		303,
		9
	],
	"./webapp/portal/settings/history/component/freespin": [
		239,
		9
	],
	"./webapp/portal/settings/history/component/freespin/": [
		239,
		9
	],
	"./webapp/portal/settings/history/component/freespin/components/freespin": [
		471,
		9
	],
	"./webapp/portal/settings/history/component/freespin/components/freespin.js": [
		471,
		9
	],
	"./webapp/portal/settings/history/component/freespin/components/m-freespin": [
		472,
		9
	],
	"./webapp/portal/settings/history/component/freespin/components/m-freespin.js": [
		472,
		9
	],
	"./webapp/portal/settings/history/component/freespin/index": [
		239,
		9
	],
	"./webapp/portal/settings/history/component/freespin/index.js": [
		239,
		9
	],
	"./webapp/portal/settings/history/component/freespin/useFreeSpin": [
		252,
		9
	],
	"./webapp/portal/settings/history/component/freespin/useFreeSpin.js": [
		252,
		9
	],
	"./webapp/portal/settings/history/component/history-detail-dialog/history-detail-dialog": [
		942,
		9,
		182
	],
	"./webapp/portal/settings/history/component/history-detail-dialog/history-detail-dialog.controller": [
		917,
		9,
		243
	],
	"./webapp/portal/settings/history/component/history-detail-dialog/history-detail-dialog.controller.js": [
		917,
		9,
		243
	],
	"./webapp/portal/settings/history/component/history-detail-dialog/history-detail-dialog.js": [
		942,
		9,
		182
	],
	"./webapp/portal/settings/history/component/mobile/m-history-landing": [
		666,
		9,
		89
	],
	"./webapp/portal/settings/history/component/mobile/m-history-landing.js": [
		666,
		9,
		89
	],
	"./webapp/portal/settings/history/component/promotion/component/m-promotion": [
		475,
		9
	],
	"./webapp/portal/settings/history/component/promotion/component/m-promotion.js": [
		475,
		9
	],
	"./webapp/portal/settings/history/component/promotion/component/promotion": [
		474,
		9
	],
	"./webapp/portal/settings/history/component/promotion/component/promotion.js": [
		474,
		9
	],
	"./webapp/portal/settings/history/component/promotion/promotion.controller": [
		82,
		9
	],
	"./webapp/portal/settings/history/component/promotion/promotion.controller.js": [
		82,
		9
	],
	"./webapp/portal/settings/history/component/promotion/promotion.selector": [
		473,
		9
	],
	"./webapp/portal/settings/history/component/promotion/promotion.selector.js": [
		473,
		9
	],
	"./webapp/portal/settings/history/component/rebate/component/m-rebate": [
		478,
		9
	],
	"./webapp/portal/settings/history/component/rebate/component/m-rebate.js": [
		478,
		9
	],
	"./webapp/portal/settings/history/component/rebate/component/rebate": [
		477,
		9
	],
	"./webapp/portal/settings/history/component/rebate/component/rebate.js": [
		477,
		9
	],
	"./webapp/portal/settings/history/component/rebate/rebate.controller": [
		63,
		9
	],
	"./webapp/portal/settings/history/component/rebate/rebate.controller.js": [
		63,
		9
	],
	"./webapp/portal/settings/history/component/rebate/rebate.selector": [
		476,
		9
	],
	"./webapp/portal/settings/history/component/rebate/rebate.selector.js": [
		476,
		9
	],
	"./webapp/portal/settings/history/component/rewards/component/m-rewards": [
		481,
		9
	],
	"./webapp/portal/settings/history/component/rewards/component/m-rewards.js": [
		481,
		9
	],
	"./webapp/portal/settings/history/component/rewards/component/rewards": [
		480,
		9
	],
	"./webapp/portal/settings/history/component/rewards/component/rewards.js": [
		480,
		9
	],
	"./webapp/portal/settings/history/component/rewards/rewards.controller": [
		77,
		9
	],
	"./webapp/portal/settings/history/component/rewards/rewards.controller.js": [
		77,
		9
	],
	"./webapp/portal/settings/history/component/rewards/rewards.selector": [
		479,
		9
	],
	"./webapp/portal/settings/history/component/rewards/rewards.selector.js": [
		479,
		9
	],
	"./webapp/portal/settings/history/component/search-dialog/search-dialog": [
		943,
		9,
		183
	],
	"./webapp/portal/settings/history/component/search-dialog/search-dialog.controller": [
		918,
		9,
		244
	],
	"./webapp/portal/settings/history/component/search-dialog/search-dialog.controller.js": [
		918,
		9,
		244
	],
	"./webapp/portal/settings/history/component/search-dialog/search-dialog.js": [
		943,
		9,
		183
	],
	"./webapp/portal/settings/history/component/sports-outstanding/hybrid/sports-outstanding": [
		490,
		9
	],
	"./webapp/portal/settings/history/component/sports-outstanding/hybrid/sports-outstanding.js": [
		490,
		9
	],
	"./webapp/portal/settings/history/component/sports-outstanding/useSportsOutstanding": [
		491,
		9
	],
	"./webapp/portal/settings/history/component/sports-outstanding/useSportsOutstanding.js": [
		491,
		9
	],
	"./webapp/portal/settings/history/component/transaction/component/m-transaction": [
		484,
		9
	],
	"./webapp/portal/settings/history/component/transaction/component/m-transaction.js": [
		484,
		9
	],
	"./webapp/portal/settings/history/component/transaction/component/transaction": [
		483,
		9
	],
	"./webapp/portal/settings/history/component/transaction/component/transaction.js": [
		483,
		9
	],
	"./webapp/portal/settings/history/component/transaction/transaction.controller": [
		78,
		9
	],
	"./webapp/portal/settings/history/component/transaction/transaction.controller.js": [
		78,
		9
	],
	"./webapp/portal/settings/history/component/transaction/transaction.selector": [
		482,
		9
	],
	"./webapp/portal/settings/history/component/transaction/transaction.selector.js": [
		482,
		9
	],
	"./webapp/portal/settings/history/component/transfer/component/m-transfer": [
		487,
		9
	],
	"./webapp/portal/settings/history/component/transfer/component/m-transfer.js": [
		487,
		9
	],
	"./webapp/portal/settings/history/component/transfer/component/transfer": [
		486,
		9
	],
	"./webapp/portal/settings/history/component/transfer/component/transfer.js": [
		486,
		9
	],
	"./webapp/portal/settings/history/component/transfer/transfer.controller": [
		67,
		9
	],
	"./webapp/portal/settings/history/component/transfer/transfer.controller.js": [
		67,
		9
	],
	"./webapp/portal/settings/history/component/transfer/transfer.selector": [
		485,
		9
	],
	"./webapp/portal/settings/history/component/transfer/transfer.selector.js": [
		485,
		9
	],
	"./webapp/portal/settings/history/history-landing.controller": [
		174,
		9
	],
	"./webapp/portal/settings/history/history-landing.controller.js": [
		174,
		9
	],
	"./webapp/portal/settings/history/history-landing.selector": [
		146,
		9
	],
	"./webapp/portal/settings/history/history-landing.selector.js": [
		146,
		9
	],
	"./webapp/portal/settings/instant-rebate/component/desktop/instant-rebate": [
		307,
		9
	],
	"./webapp/portal/settings/instant-rebate/component/desktop/instant-rebate.js": [
		307,
		9
	],
	"./webapp/portal/settings/instant-rebate/component/mobile/m-instant-rebate": [
		665,
		9,
		79
	],
	"./webapp/portal/settings/instant-rebate/component/mobile/m-instant-rebate.js": [
		665,
		9,
		79
	],
	"./webapp/portal/settings/instant-rebate/instant-rebate.controller": [
		103,
		9
	],
	"./webapp/portal/settings/instant-rebate/instant-rebate.controller.js": [
		103,
		9
	],
	"./webapp/portal/settings/instant-rebate/instant-rebate.selector": [
		504,
		9
	],
	"./webapp/portal/settings/instant-rebate/instant-rebate.selector.js": [
		504,
		9
	],
	"./webapp/portal/settings/instant-rebate/sub-component/history-popup/desktop/history-popup": [
		378,
		9
	],
	"./webapp/portal/settings/instant-rebate/sub-component/history-popup/desktop/history-popup.js": [
		378,
		9
	],
	"./webapp/portal/settings/instant-rebate/sub-component/history-popup/history-popup.selector": [
		944,
		9,
		184
	],
	"./webapp/portal/settings/instant-rebate/sub-component/history-popup/history-popup.selector.js": [
		944,
		9,
		184
	],
	"./webapp/portal/settings/instant-rebate/sub-component/history-popup/mobile/history-popup": [
		837,
		9,
		245
	],
	"./webapp/portal/settings/instant-rebate/sub-component/history-popup/mobile/history-popup.js": [
		837,
		9,
		245
	],
	"./webapp/portal/settings/landing/component/MemberProfile": [
		836,
		9,
		185
	],
	"./webapp/portal/settings/landing/component/MemberProfile.js": [
		836,
		9,
		185
	],
	"./webapp/portal/settings/landing/component/SettingLanding": [
		901,
		9,
		123
	],
	"./webapp/portal/settings/landing/component/SettingLanding.js": [
		901,
		9,
		123
	],
	"./webapp/portal/settings/landing/component/myAccountSummary": [
		505,
		9
	],
	"./webapp/portal/settings/landing/component/myAccountSummary.js": [
		505,
		9
	],
	"./webapp/portal/settings/landing/component/navbarMyAccount": [
		419,
		9
	],
	"./webapp/portal/settings/landing/component/navbarMyAccount.js": [
		419,
		9
	],
	"./webapp/portal/settings/landing/member.controller": [
		802,
		9,
		246
	],
	"./webapp/portal/settings/landing/member.controller.js": [
		802,
		9,
		246
	],
	"./webapp/portal/settings/landing/settings.controller": [
		237,
		9
	],
	"./webapp/portal/settings/landing/settings.controller.js": [
		237,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/component/m-message-detail-dialog": [
		499,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/component/m-message-detail-dialog.js": [
		499,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/component/message-detail-dialog": [
		498,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/component/message-detail-dialog.js": [
		498,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/message-detail-dialog.controller": [
		216,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/message-detail-dialog.controller.js": [
		216,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/message-detail-dialog.selector": [
		377,
		9
	],
	"./webapp/portal/settings/message-detail-dialog/message-detail-dialog.selector.js": [
		377,
		9
	],
	"./webapp/portal/settings/message/component/desktop/message": [
		305,
		9
	],
	"./webapp/portal/settings/message/component/desktop/message.js": [
		305,
		9
	],
	"./webapp/portal/settings/message/component/mobile/m-message": [
		663,
		9,
		90
	],
	"./webapp/portal/settings/message/component/mobile/m-message.js": [
		663,
		9,
		90
	],
	"./webapp/portal/settings/message/message.controller": [
		62,
		9
	],
	"./webapp/portal/settings/message/message.controller.js": [
		62,
		9
	],
	"./webapp/portal/settings/message/message.selector": [
		495,
		9
	],
	"./webapp/portal/settings/message/message.selector.js": [
		495,
		9
	],
	"./webapp/portal/settings/mobile/m-transfer": [
		945,
		9,
		146
	],
	"./webapp/portal/settings/mobile/m-transfer.js": [
		945,
		9,
		146
	],
	"./webapp/portal/settings/mobile/transfer/m-transferSelect": [
		919,
		9,
		247
	],
	"./webapp/portal/settings/mobile/transfer/m-transferSelect.js": [
		919,
		9,
		247
	],
	"./webapp/portal/settings/mobile/transfer/m-turnover": [
		920,
		9,
		248
	],
	"./webapp/portal/settings/mobile/transfer/m-turnover.js": [
		920,
		9,
		248
	],
	"./webapp/portal/settings/mobilecard-redirect/mobilecard-redirect": [
		659,
		9,
		91
	],
	"./webapp/portal/settings/mobilecard-redirect/mobilecard-redirect.js": [
		659,
		9,
		91
	],
	"./webapp/portal/settings/password/component/desktop/password": [
		621,
		9,
		52
	],
	"./webapp/portal/settings/password/component/desktop/password.js": [
		621,
		9,
		52
	],
	"./webapp/portal/settings/password/component/mobile/m-password": [
		622,
		9,
		46
	],
	"./webapp/portal/settings/password/component/mobile/m-password.js": [
		622,
		9,
		46
	],
	"./webapp/portal/settings/password/password.controller": [
		807,
		9,
		249
	],
	"./webapp/portal/settings/password/password.controller.js": [
		807,
		9,
		249
	],
	"./webapp/portal/settings/password/password.selector": [
		285,
		9
	],
	"./webapp/portal/settings/password/password.selector.js": [
		285,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/component/m-phone-verification-dialog": [
		462,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/component/m-phone-verification-dialog.js": [
		462,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/component/phone-verification-dialog": [
		461,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/component/phone-verification-dialog.js": [
		461,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/phone-verification-dialog.controller": [
		100,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/phone-verification-dialog.controller.js": [
		100,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/phone-verification-dialog.selector": [
		368,
		9
	],
	"./webapp/portal/settings/phone-verification-dialog/phone-verification-dialog.selector.js": [
		368,
		9
	],
	"./webapp/portal/settings/profile/component/desktop/profile": [
		304,
		9
	],
	"./webapp/portal/settings/profile/component/desktop/profile.js": [
		304,
		9
	],
	"./webapp/portal/settings/profile/component/mobile/m-profile": [
		661,
		9,
		80
	],
	"./webapp/portal/settings/profile/component/mobile/m-profile.js": [
		661,
		9,
		80
	],
	"./webapp/portal/settings/profile/profile.controller": [
		120,
		9
	],
	"./webapp/portal/settings/profile/profile.controller.js": [
		120,
		9
	],
	"./webapp/portal/settings/profile/profile.selector": [
		492,
		9
	],
	"./webapp/portal/settings/profile/profile.selector.js": [
		492,
		9
	],
	"./webapp/portal/settings/profile/subcomponent/desktop/edit-dob-popup": [
		493,
		9
	],
	"./webapp/portal/settings/profile/subcomponent/desktop/edit-dob-popup.js": [
		493,
		9
	],
	"./webapp/portal/settings/profile/subcomponent/edit-dob-popup.controller": [
		195,
		9
	],
	"./webapp/portal/settings/profile/subcomponent/edit-dob-popup.controller.js": [
		195,
		9
	],
	"./webapp/portal/settings/profile/subcomponent/mobile/edit-dob-popup": [
		904,
		9,
		250
	],
	"./webapp/portal/settings/profile/subcomponent/mobile/edit-dob-popup.js": [
		904,
		9,
		250
	],
	"./webapp/portal/settings/promotion-details-dialog/component/m-promotion-details-dialog": [
		463,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/component/m-promotion-details-dialog.js": [
		463,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/component/promotion-details-dialog": [
		464,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/component/promotion-details-dialog.js": [
		464,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/promotion-details-dialog.controller": [
		248,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/promotion-details-dialog.controller.js": [
		248,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/promotion-details-dialog.selector": [
		369,
		9
	],
	"./webapp/portal/settings/promotion-details-dialog/promotion-details-dialog.selector.js": [
		369,
		9
	],
	"./webapp/portal/settings/qrcode-dialog/component/desktop/qrcode-dialog": [
		298,
		9
	],
	"./webapp/portal/settings/qrcode-dialog/component/desktop/qrcode-dialog.js": [
		298,
		9
	],
	"./webapp/portal/settings/qrcode-dialog/qrcode-dialog.selector": [
		247,
		9
	],
	"./webapp/portal/settings/qrcode-dialog/qrcode-dialog.selector.js": [
		247,
		9
	],
	"./webapp/portal/settings/quickpay-redirect/quickpay-redirect": [
		658,
		9,
		92
	],
	"./webapp/portal/settings/quickpay-redirect/quickpay-redirect.js": [
		658,
		9,
		92
	],
	"./webapp/portal/settings/referral/component/desktop/mybonus": [
		858,
		9,
		252
	],
	"./webapp/portal/settings/referral/component/desktop/mybonus-comm": [
		859,
		9,
		251
	],
	"./webapp/portal/settings/referral/component/desktop/mybonus-comm.js": [
		859,
		9,
		251
	],
	"./webapp/portal/settings/referral/component/desktop/mybonus.js": [
		858,
		9,
		252
	],
	"./webapp/portal/settings/referral/component/desktop/myreferral": [
		857,
		9,
		253
	],
	"./webapp/portal/settings/referral/component/desktop/myreferral.js": [
		857,
		9,
		253
	],
	"./webapp/portal/settings/referral/component/desktop/referral": [
		623,
		9,
		47
	],
	"./webapp/portal/settings/referral/component/desktop/referral.js": [
		623,
		9,
		47
	],
	"./webapp/portal/settings/referral/component/mobile/m-referral": [
		548,
		9,
		19
	],
	"./webapp/portal/settings/referral/component/mobile/m-referral.js": [
		548,
		9,
		19
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus": [
		946,
		9,
		148
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus-comm": [
		862,
		9,
		147
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus-comm.js": [
		862,
		9,
		147
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus-details": [
		797,
		9,
		254
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus-details.js": [
		797,
		9,
		254
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus.js": [
		946,
		9,
		148
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus2": [
		861,
		9,
		255
	],
	"./webapp/portal/settings/referral/component/mobile/mybonus2.js": [
		861,
		9,
		255
	],
	"./webapp/portal/settings/referral/component/mobile/myreferral": [
		860,
		9,
		186
	],
	"./webapp/portal/settings/referral/component/mobile/myreferral.js": [
		860,
		9,
		186
	],
	"./webapp/portal/settings/referral/component/mobile/searchModal": [
		796,
		9,
		256
	],
	"./webapp/portal/settings/referral/component/mobile/searchModal.js": [
		796,
		9,
		256
	],
	"./webapp/portal/settings/referral/component/mobile/termsModal": [
		947,
		9,
		257
	],
	"./webapp/portal/settings/referral/component/mobile/termsModal.js": [
		947,
		9,
		257
	],
	"./webapp/portal/settings/referral/referral.controller": [
		809,
		9,
		124
	],
	"./webapp/portal/settings/referral/referral.controller.js": [
		809,
		9,
		124
	],
	"./webapp/portal/settings/referral/referral.selector": [
		503,
		9
	],
	"./webapp/portal/settings/referral/referral.selector.js": [
		503,
		9
	],
	"./webapp/portal/settings/settings-data": [
		422,
		9
	],
	"./webapp/portal/settings/settings-data.js": [
		422,
		9
	],
	"./webapp/portal/settings/settings.selector": [
		657,
		9,
		61
	],
	"./webapp/portal/settings/settings.selector.js": [
		657,
		9,
		61
	],
	"./webapp/portal/settings/special-promo-dialog/component/m-special-promo-dialog": [
		466,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/component/m-special-promo-dialog.js": [
		466,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/component/special-promo-dialog": [
		465,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/component/special-promo-dialog.js": [
		465,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/special-promo-dialog.controller": [
		249,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/special-promo-dialog.controller.js": [
		249,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/special-promo-dialog.selector": [
		370,
		9
	],
	"./webapp/portal/settings/special-promo-dialog/special-promo-dialog.selector.js": [
		370,
		9
	],
	"./webapp/portal/settings/transfer/component/desktop/transfer": [
		299,
		9
	],
	"./webapp/portal/settings/transfer/component/desktop/transfer.js": [
		299,
		9
	],
	"./webapp/portal/settings/transfer/component/desktop/transferSelect": [
		301,
		9
	],
	"./webapp/portal/settings/transfer/component/desktop/transferSelect.js": [
		301,
		9
	],
	"./webapp/portal/settings/transfer/component/desktop/turnover": [
		467,
		9
	],
	"./webapp/portal/settings/transfer/component/desktop/turnover.js": [
		467,
		9
	],
	"./webapp/portal/settings/transfer/component/mobile/m-transfer": [
		660,
		9,
		75
	],
	"./webapp/portal/settings/transfer/component/mobile/m-transfer.js": [
		660,
		9,
		75
	],
	"./webapp/portal/settings/transfer/component/mobile/m-transferSelect": [
		902,
		9,
		258
	],
	"./webapp/portal/settings/transfer/component/mobile/m-transferSelect.js": [
		902,
		9,
		258
	],
	"./webapp/portal/settings/transfer/component/mobile/m-turnover": [
		903,
		9,
		259
	],
	"./webapp/portal/settings/transfer/component/mobile/m-turnover.js": [
		903,
		9,
		259
	],
	"./webapp/portal/settings/transfer/transfer.controller": [
		50,
		9
	],
	"./webapp/portal/settings/transfer/transfer.controller.js": [
		50,
		9
	],
	"./webapp/portal/settings/transfer/transfer.selector": [
		460,
		9
	],
	"./webapp/portal/settings/transfer/transfer.selector.js": [
		460,
		9
	],
	"./webapp/portal/settings/withdraw/component/desktop/ewallet": [
		371,
		9
	],
	"./webapp/portal/settings/withdraw/component/desktop/ewallet.js": [
		371,
		9
	],
	"./webapp/portal/settings/withdraw/component/desktop/withdraw": [
		302,
		9
	],
	"./webapp/portal/settings/withdraw/component/desktop/withdraw.js": [
		302,
		9
	],
	"./webapp/portal/settings/withdraw/component/mobile/m-withdraw": [
		664,
		9,
		93
	],
	"./webapp/portal/settings/withdraw/component/mobile/m-withdraw.js": [
		664,
		9,
		93
	],
	"./webapp/portal/settings/withdraw/ewallet.controller": [
		85,
		9
	],
	"./webapp/portal/settings/withdraw/ewallet.controller.js": [
		85,
		9
	],
	"./webapp/portal/settings/withdraw/withdraw.controller": [
		37,
		9
	],
	"./webapp/portal/settings/withdraw/withdraw.controller.js": [
		37,
		9
	],
	"./webapp/portal/settings/withdraw/withdraw.selector": [
		468,
		9
	],
	"./webapp/portal/settings/withdraw/withdraw.selector.js": [
		468,
		9
	],
	"./webapp/portal/sponsorship/sponsorship": [
		928,
		9,
		76
	],
	"./webapp/portal/sponsorship/sponsorship.controller": [
		921,
		9,
		187
	],
	"./webapp/portal/sponsorship/sponsorship.controller.js": [
		921,
		9,
		187
	],
	"./webapp/portal/sponsorship/sponsorship.js": [
		928,
		9,
		76
	],
	"./webapp/portal/sponsorship/sponsorship.selector": [
		646,
		9,
		94
	],
	"./webapp/portal/sponsorship/sponsorship.selector.js": [
		646,
		9,
		94
	],
	"./webapp/portal/telegram/telegram-button": [
		236,
		9
	],
	"./webapp/portal/telegram/telegram-button.js": [
		236,
		9
	],
	"./webapp/portal/telegram/telegram-button.module.scss": [
		110,
		7
	],
	"./webapp/portal/terms/component/terms": [
		893,
		9,
		188
	],
	"./webapp/portal/terms/component/terms.js": [
		893,
		9,
		188
	],
	"./webapp/portal/terms/terms.controller": [
		834,
		9,
		260
	],
	"./webapp/portal/terms/terms.controller.js": [
		834,
		9,
		260
	],
	"./webapp/portal/terms/terms.selector": [
		643,
		9,
		77
	],
	"./webapp/portal/terms/terms.selector.js": [
		643,
		9,
		77
	],
	"./webapp/portal/vip/desktop/Vip": [
		894,
		9,
		0,
		149
	],
	"./webapp/portal/vip/desktop/Vip.js": [
		894,
		9,
		0,
		149
	],
	"./webapp/portal/vip/mobile/Vip": [
		895,
		9,
		0,
		110
	],
	"./webapp/portal/vip/mobile/Vip.js": [
		895,
		9,
		0,
		110
	],
	"./webapp/portal/vip/vip.controller": [
		794,
		9,
		261
	],
	"./webapp/portal/vip/vip.controller.js": [
		794,
		9,
		261
	],
	"./webapp/portal/vip/vip.selector": [
		644,
		9,
		0,
		53
	],
	"./webapp/portal/vip/vip.selector.js": [
		644,
		9,
		0,
		53
	],
	"./webapp/route-config": [
		262,
		9
	],
	"./webapp/route-config.js": [
		262,
		9
	],
	"./webapp/shared/announcement-popup/announcement-popup.selector": [
		848,
		9,
		81
	],
	"./webapp/shared/announcement-popup/announcement-popup.selector.js": [
		848,
		9,
		81
	],
	"./webapp/shared/announcement-popup/component/announcement-popup": [
		842,
		9,
		262
	],
	"./webapp/shared/announcement-popup/component/announcement-popup.js": [
		842,
		9,
		262
	],
	"./webapp/shared/component/Clock": [
		409,
		9
	],
	"./webapp/shared/component/Clock.js": [
		409,
		9
	],
	"./webapp/shared/component/Dropdown_Langlist": [
		410,
		9
	],
	"./webapp/shared/component/Dropdown_Langlist.js": [
		410,
		9
	],
	"./webapp/shared/component/Footer": [
		948,
		9,
		263
	],
	"./webapp/shared/component/Footer.js": [
		948,
		9,
		263
	],
	"./webapp/shared/component/GameList": [
		757,
		9,
		161
	],
	"./webapp/shared/component/GameList.js": [
		757,
		9,
		161
	],
	"./webapp/shared/component/JackpotCarousel": [
		814,
		9,
		150
	],
	"./webapp/shared/component/JackpotCarousel.js": [
		814,
		9,
		150
	],
	"./webapp/shared/component/LangDisplay": [
		380,
		9
	],
	"./webapp/shared/component/LangDisplay.js": [
		380,
		9
	],
	"./webapp/shared/component/Notice": [
		785,
		9,
		264
	],
	"./webapp/shared/component/Notice.js": [
		785,
		9,
		264
	],
	"./webapp/shared/component/RecommendGames": [
		815,
		9,
		162
	],
	"./webapp/shared/component/RecommendGames.js": [
		815,
		9,
		162
	],
	"./webapp/shared/component/Slider": [
		752,
		9,
		0,
		265
	],
	"./webapp/shared/component/Slider.js": [
		752,
		9,
		0,
		265
	],
	"./webapp/shared/component/Slider2": [
		762,
		9,
		266
	],
	"./webapp/shared/component/Slider2.js": [
		762,
		9,
		266
	],
	"./webapp/shared/component/mobileSelect/mobileSelect": [
		38,
		9
	],
	"./webapp/shared/component/mobileSelect/mobileSelect.js": [
		38,
		9
	],
	"./webapp/shared/component/provider-select": [
		897,
		9,
		267
	],
	"./webapp/shared/component/provider-select.js": [
		897,
		9,
		267
	],
	"./webapp/shared/component/wap/BottomNavbar": [
		507,
		9
	],
	"./webapp/shared/component/wap/BottomNavbar.js": [
		507,
		9
	],
	"./webapp/shared/component/wap/GameMenu": [
		949,
		9,
		268
	],
	"./webapp/shared/component/wap/GameMenu.js": [
		949,
		9,
		268
	],
	"./webapp/shared/component/wap/HomeMemberProfile": [
		754,
		9,
		189
	],
	"./webapp/shared/component/wap/HomeMemberProfile.js": [
		754,
		9,
		189
	],
	"./webapp/shared/component/wap/LeftSubMenu": [
		756,
		9,
		269
	],
	"./webapp/shared/component/wap/LeftSubMenu.js": [
		756,
		9,
		269
	],
	"./webapp/shared/component/wap/home-member-profile.controller": [
		753,
		9,
		270
	],
	"./webapp/shared/component/wap/home-member-profile.controller.js": [
		753,
		9,
		270
	],
	"./webapp/shared/floating-notification/floating-notification": [
		292,
		9
	],
	"./webapp/shared/floating-notification/floating-notification-content": [
		293,
		9
	],
	"./webapp/shared/floating-notification/floating-notification-content.js": [
		293,
		9
	],
	"./webapp/shared/floating-notification/floating-notification.controller": [
		177,
		9
	],
	"./webapp/shared/floating-notification/floating-notification.controller.js": [
		177,
		9
	],
	"./webapp/shared/floating-notification/floating-notification.js": [
		292,
		9
	],
	"./webapp/shared/floating-notification/notification-list": [
		407,
		9
	],
	"./webapp/shared/floating-notification/notification-list.js": [
		407,
		9
	],
	"./webapp/shared/image-helper/image-helper": [
		86,
		9
	],
	"./webapp/shared/image-helper/image-helper.js": [
		86,
		9
	],
	"./webapp/shared/lazyComponent": [
		135,
		9
	],
	"./webapp/shared/lazyComponent.js": [
		135,
		9
	],
	"./webapp/shared/loading/loading": [
		166,
		9
	],
	"./webapp/shared/loading/loading.js": [
		166,
		9
	],
	"./webapp/shared/loading/smallLoading": [
		31,
		9
	],
	"./webapp/shared/loading/smallLoading.js": [
		31,
		9
	],
	"./webapp/shared/pagination/component/pagination": [
		619,
		9,
		16,
		95
	],
	"./webapp/shared/pagination/component/pagination.js": [
		619,
		9,
		16,
		95
	],
	"./webapp/shared/pagination/component/pagination02": [
		620,
		9,
		16,
		96
	],
	"./webapp/shared/pagination/component/pagination02.js": [
		620,
		9,
		16,
		96
	],
	"./webapp/shared/pagination/pagination.selector": [
		49,
		9
	],
	"./webapp/shared/pagination/pagination.selector.js": [
		49,
		9
	],
	"./webapp/shared/privateRoute": [
		950,
		9,
		271
	],
	"./webapp/shared/privateRoute.js": [
		950,
		9,
		271
	],
	"./webapp/shared/reward-popup/component/reward-popup": [
		381,
		9
	],
	"./webapp/shared/reward-popup/component/reward-popup.js": [
		381,
		9
	],
	"./webapp/shared/reward-popup/reward-popup.selector": [
		951,
		9,
		272
	],
	"./webapp/shared/reward-popup/reward-popup.selector.js": [
		951,
		9,
		272
	],
	"./webapp/shared/scrollToTop/scrollToTop": [
		291,
		9
	],
	"./webapp/shared/scrollToTop/scrollToTop.js": [
		291,
		9
	],
	"./webapp/shared/shareModal/shareModal": [
		810,
		9,
		273
	],
	"./webapp/shared/shareModal/shareModal.js": [
		810,
		9,
		273
	],
	"./webapp/shared/slider-helper/slider-helper": [
		804,
		9,
		274
	],
	"./webapp/shared/slider-helper/slider-helper.js": [
		804,
		9,
		274
	],
	"./webapp/shared/sliderRecaptcha-popup/desktop/sliderRecaptcha-popup": [
		812,
		9,
		275
	],
	"./webapp/shared/sliderRecaptcha-popup/desktop/sliderRecaptcha-popup.js": [
		812,
		9,
		275
	],
	"./webapp/shared/sliderRecaptcha-popup/mobile/sliderRecaptcha-popup": [
		813,
		9,
		276
	],
	"./webapp/shared/sliderRecaptcha-popup/mobile/sliderRecaptcha-popup.js": [
		813,
		9,
		276
	],
	"./webapp/shared/sliderRecaptcha-popup/sliderRecaptcha-popup.selector": [
		865,
		9,
		151
	],
	"./webapp/shared/sliderRecaptcha-popup/sliderRecaptcha-popup.selector.js": [
		865,
		9,
		151
	],
	"./webapp/shared/transaction-note/component/transaction-note": [
		175,
		9
	],
	"./webapp/shared/transaction-note/component/transaction-note.js": [
		175,
		9
	],
	"./webapp/shared/transaction-note/transaction-note.controller": [
		297,
		9
	],
	"./webapp/shared/transaction-note/transaction-note.controller.js": [
		297,
		9
	],
	"./webapp/shared/transaction-note/transaction-note.selector": [
		32,
		9
	],
	"./webapp/shared/transaction-note/transaction-note.selector.js": [
		32,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1352;
module.exports = webpackAsyncContext;